(() => {
  // Retire old New / Used filter links without leaving an invisible filter active.
  if (/^\/(collections|search)(?:\/|$)/.test(location.pathname)) {
    const cleanUrl = new URL(location.href);
    const cleanHash = new URLSearchParams(cleanUrl.hash.slice(1));
    if (cleanUrl.searchParams.has('filter.p.m.catalog.new_or_used') || cleanHash.has('newused')) {
      cleanUrl.searchParams.delete('filter.p.m.catalog.new_or_used');
      cleanUrl.searchParams.delete('page');
      cleanHash.delete('newused');
      cleanUrl.hash = cleanHash.toString();
      location.replace(cleanUrl);
      return;
    }
  }
  // Expand catalog abbreviations for shoppers; preserve submitted option values.
  const displayOptionValue = value => String(value || '').trim().replace(/\s+/g, ' ')
    .replace(/^(?:wns|wms|womens|women's|womans|woman's)\s*(?:(?:size|sz)\s*)?(?=\d)/i, "Women's ")
    .replace(/^(?:mens|men's)\s*(?:(?:size|sz)\s*)?(?=\d)/i, "Men's ")
    .replace(/^youth\s+(?:size|sz)\s*/i, 'Youth ')
    .replace(/^mondo\s*/i, 'Mondo ')
    .replace(/^EU Shoe\s+/i, 'EU ')
    .replace(/^one[ -]size$/i, 'One Size');
  const displayChoiceTitle = value => String(value || '').split(' / ').map(part => {
    const separator = part.indexOf(': ');
    return separator < 0 ? displayOptionValue(part) : part.slice(0, separator + 2) + displayOptionValue(part.slice(separator + 2));
  }).join(' / ');
  const polishOptionLabels = root => {
    const selector = '.product-card__option-chip, .product-options .option-values label > span, .product-card__choice-values strong, .cart-item__option-value';
    const nodes = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) nodes.unshift(root);
    nodes.forEach(node => {
      const label = displayOptionValue(node.textContent);
      if (node.textContent !== label) node.textContent = label;
    });
    const choices = [...root.querySelectorAll('[data-card-choice]')];
    if (root.matches?.('[data-card-choice]')) choices.unshift(root);
    choices.forEach(choice => { choice.dataset.choiceTitle = displayChoiceTitle(choice.dataset.choiceTitle); });
  };
  polishOptionLabels(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) polishOptionLabels(node);
  }))).observe(document.body, {childList: true, subtree: true});

  const money = (cents) => {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  };

  const drawer = document.querySelector('[data-cart-drawer]');
  if (drawer && drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }
  const drawerPanel = drawer?.querySelector('.cart-drawer__panel');
  const drawerContent = document.querySelector('[data-cart-drawer-content]');
  const drawerTotals = document.querySelector('[data-cart-drawer-totals]');
  const drawerSubtotal = document.querySelector('[data-cart-drawer-subtotal]');
  const drawerShipping = document.querySelector('[data-cart-drawer-shipping]');
  const countNodes = document.querySelectorAll('[data-cart-count]');
  let drawerHideTimer = null;

  const safe = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[char]));

  const preparedPulse = (node) => {
    if (!node) return;
    node.classList.add('is-prepared-clicked');
    window.setTimeout(() => node.classList.remove('is-prepared-clicked'), 520);
  };

  const pressNode = (node, pressed) => {
    if (!node) return;
    node.classList.toggle('is-pressing', pressed);
  };

  const preparedNavigationNode = document.getElementById('GearonimoPreparedNavigation');
  const preparedNavigation = (() => {
    try {
      return JSON.parse(preparedNavigationNode?.textContent || '[]');
    } catch (error) {
      return [];
    }
  })();

  const normalizeCategorySearch = (value) => String(value || '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const normalizeFilterSearch = (value) => String(value || '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9.$<>/=+-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const levenshteinDistance = (left, right) => {
    const a = left || '';
    const b = right || '';
    const rows = Array(a.length + 1).fill(0).map((_, index) => index);
    let prev = Array(a.length + 1).fill(0);
    let curr = Array(a.length + 1).fill(0);

    for (let i = 0; i < b.length; i += 1) {
      prev = [...rows];
      curr[0] = i + 1;
      for (let j = 0; j < a.length; j += 1) {
        const leftCost = prev[j + 1] + 1;
        const upCost = curr[j] + 1;
        const diagonalCost = prev[j] + (a[j] === b[i] ? 0 : 1);
        curr[j + 1] = Math.min(leftCost, upCost, diagonalCost);
      }
      rows.splice(0, rows.length, ...curr);
    }

    return rows[a.length] || 0;
  };

  const commonSearchStopwords = new Set(['and', 'the', 'for', 'from', 'with', 'that', 'this', 'your', 'you']);
  const tokenizeSearch = (value) => normalizeCategorySearch(value)
    .split(' ')
    .filter((token) => token && token.length > 1 && !commonSearchStopwords.has(token));

  const tokenSimilarity = (query, term) => {
    const queryTokens = tokenizeSearch(query);
    const termTokens = tokenizeSearch(term);
    if (!queryTokens.length || !termTokens.length) return 0;

    let overlap = 0;
    queryTokens.forEach((queryToken) => {
      const bestMatch = termTokens.some((termToken) => (
        termToken === queryToken
          || termToken.includes(queryToken)
          || queryToken.includes(termToken)
          || levenshteinDistance(termToken, queryToken) <= 1
      ));
      if (bestMatch) overlap += 1;
    });

    const overlapScore = overlap / Math.max(queryTokens.length, termTokens.length);
    const distance = levenshteinDistance(query, term);
    const lengthScore = 1 - Math.min(1, distance / Math.max(query.length, term.length, 1));
    return (overlapScore * 0.72) + (lengthScore * 0.28);
  };

  const searchTokenCorrections = new Map(Object.entries({
    accesories: 'accessories',
    accesoriez: 'accessories',
    addres: 'address',
    adress: 'address',
    adlt: 'adult',
    appoitment: 'appointment',
    apointment: 'appointment',
    apparrel: 'apparel',
    avlanche: 'avalanche',
    avalanch: 'avalanche',
    backpaks: 'backpacks',
    backpak: 'backpack',
    backpakc: 'backpack',
    bik: 'bike',
    biks: 'bikes',
    bindigns: 'bindings',
    bindngs: 'bindings',
    blck: 'black',
    booots: 'boots',
    botts: 'boots',
    botos: 'boots',
    cambr: 'camber',
    campng: 'camping',
    caribiners: 'carabiners',
    carbiners: 'carabiners',
    categry: 'category',
    cateogry: 'category',
    climbng: 'climbing',
    climbin: 'climbing',
    clibming: 'climbing',
    climing: 'climbing',
    climibng: 'climbing',
    clothign: 'clothing',
    clothng: 'clothing',
    clohting: 'clothing',
    cloathing: 'clothing',
    clothes: 'clothing',
    conditon: 'condition',
    condtion: 'condition',
    conact: 'contact',
    contcat: 'contact',
    contct: 'contact',
    cotact: 'contact',
    diamnd: 'diamond',
    dimond: 'diamond',
    directons: 'directions',
    exchage: 'exchange',
    exchagne: 'exchange',
    footware: 'footwear',
    foootwear: 'footwear',
    glvoes: 'gloves',
    helment: 'helmet',
    helments: 'helmets',
    hicking: 'hiking',
    hikng: 'hiking',
    instroe: 'instore',
    jakcet: 'jacket',
    jakets: 'jackets',
    kyak: 'kayak',
    kyaks: 'kayaks',
    mountian: 'mountain',
    mountaineerng: 'mountaineering',
    patagoinia: 'patagonia',
    patgonia: 'patagonia',
    pattagonia: 'patagonia',
    pols: 'poles',
    privecy: 'privacy',
    privicy: 'privacy',
    questons: 'questions',
    rackes: 'racks',
    rantal: 'rental',
    rentl: 'rental',
    retrun: 'return',
    retun: 'return',
    retunrs: 'returns',
    retirns: 'returns',
    retruns: 'returns',
    salamon: 'salomon',
    saloman: 'salomon',
    shippping: 'shipping',
    shippin: 'shipping',
    shippiunf: 'shipping',
    shippiung: 'shipping',
    shiping: 'shipping',
    shoess: 'shoes',
    skii: 'ski',
    skiis: 'skis',
    skiss: 'skis',
    sksiz: 'skis',
    skatebaord: 'skateboard',
    skatebaords: 'skateboards',
    skatebord: 'skateboard',
    skatebords: 'skateboards',
    snwo: 'snow',
    snoboard: 'snowboard',
    snoboards: 'snowboards',
    snowbaord: 'snowboard',
    snowbaords: 'snowboards',
    snowboardd: 'snowboard',
    snowborad: 'snowboard',
    snowbord: 'snowboard',
    snowbords: 'snowboards',
    snowboad: 'snowboard',
    snowboads: 'snowboards',
    snowshooes: 'snowshoes',
    snowshoez: 'snowshoes',
    snowboardng: 'snowboarding',
    snowboars: 'snowboards',
    sotre: 'store',
    storee: 'store',
    tentz: 'tents',
    tunning: 'tuning',
    tuneing: 'tuning',
    watre: 'water',
    waxx: 'wax'
  }));

  const collectPreparedVocabularyTerms = (items) => {
    const terms = new Set();
    const visit = (item) => {
      if (!item) return;
      tokenizeSearch(item.label || '').forEach((term) => terms.add(term));
      (item.groups || []).forEach(visit);
      (item.items || []).forEach(visit);
    };

    (items || []).forEach(visit);
    return [...terms];
  };

  const searchCorrectionVocabulary = [
    'accessories',
    'address',
    'adult',
    'alpine',
    'apparel',
    'appointment',
    'approach',
    'arcteryx',
    'atomic',
    'avalanche',
    'backcountry',
    'backpack',
    'backpacks',
    'bags',
    'beacons',
    'belay',
    'bike',
    'bikes',
    'bindings',
    'bibs',
    'black',
    'boards',
    'boats',
    'boots',
    'bottoms',
    'burton',
    'camber',
    'camp',
    'camping',
    'cam',
    'cams',
    'carabiners',
    'cash',
    'child',
    'children',
    'climbing',
    'clothing',
    'condition',
    'contact',
    'cooking',
    'country',
    'crampons',
    'credit',
    'cross',
    'diamond',
    'directions',
    'drivetrain',
    'exchange',
    'faq',
    'fischer',
    'fleece',
    'fleeces',
    'footwear',
    'gear',
    'gloves',
    'hardgoods',
    'hardshell',
    'hardshells',
    'hardware',
    'harness',
    'harnesses',
    'helmet',
    'helmets',
    'hex',
    'hexes',
    'hike',
    'hiking',
    'hours',
    'hydration',
    'instore',
    'jacket',
    'jackets',
    'kayak',
    'kayaks',
    'kids',
    'kitchen',
    'length',
    'local',
    'maintenance',
    'marmot',
    'men',
    'mens',
    'midlayer',
    'midlayers',
    'mondo',
    'mountaineering',
    'mountain',
    'new',
    'nordic',
    'nut',
    'nuts',
    'osprey',
    'outerwear',
    'pads',
    'pans',
    'pants',
    'patagonia',
    'poles',
    'privacy',
    'products',
    'protection',
    'puffy',
    'puffies',
    'questions',
    'quickdraw',
    'quickdraws',
    'rain',
    'racks',
    'rating',
    'refund',
    'rent',
    'rental',
    'rentals',
    'return',
    'returns',
    'rocker',
    'rope',
    'ropes',
    'salomon',
    'sandals',
    'scarpa',
    'shell',
    'shells',
    'shifting',
    'shipping',
    'shoes',
    'ski',
    'skis',
    'skateboard',
    'skateboards',
    'skin',
    'skins',
    'sleeping',
    'sling',
    'slings',
    'snow',
    'snowboard',
    'snowboarding',
    'snowboards',
    'snowshoe',
    'snowshoes',
    'stoves',
    'store',
    'story',
    'terms',
    'tents',
    'thule',
    'tips',
    'trade',
    'travel',
    'tune',
    'tuning',
    'women',
    'womens',
    'used',
    'water',
    'wax'
  ];

  searchCorrectionVocabulary.push(...collectPreparedVocabularyTerms(preparedNavigation));

  const correctSearchWord = (token) => {
    if (!token || token.length < 3 || /[0-9.$<>/=+-]/.test(token)) return token;
    if (searchTokenCorrections.has(token)) return searchTokenCorrections.get(token);
    if (searchCorrectionVocabulary.includes(token)) return token;

    let bestToken = '';
    let bestDistance = Infinity;
    searchCorrectionVocabulary.forEach((candidate) => {
      if (!candidate || candidate[0] !== token[0]) return;
      const maxLength = Math.max(candidate.length, token.length);
      const lengthGap = Math.abs(candidate.length - token.length);
      if (lengthGap > 3) return;
      const distance = levenshteinDistance(token, candidate);
      const allowedDistance = maxLength >= 8 ? 2 : maxLength >= 6 ? 2 : 1;
      if (distance <= allowedDistance && distance < bestDistance) {
        bestDistance = distance;
        bestToken = candidate;
      }
    });

    return bestToken || token;
  };

  const correctSearchSpelling = (value, options = {}) => {
    const normalized = options.preserveFilterChars ? normalizeFilterSearch(value) : normalizeCategorySearch(value);
    if (!normalized) return '';

    return normalized
      .split(' ')
      .map(correctSearchWord)
      .join(' ')
      .replace(/\barc\s+teryx\b/g, 'arcteryx')
      .replace(/\bnorth\s+face\b/g, 'north face')
      .trim();
  };

  const pageSearchIntents = [
    { url: '/pages/contact', terms: ['contact', 'contact us', 'phone', 'hours', 'address', 'location', 'reach us', 'get in touch', 'call us'] },
    { url: '/pages/our-story', terms: ['about us', 'our story', 'about gearonimo', 'about gearonimo sports', 'who are we', 'brand story', 'about the store'] },
    { url: '/pages/condition-rating', terms: ['condition rating', 'gear rating', 'product rating', 'how rated', '5 star', '4 star', '3 star'] },
    { url: '/pages/condition-rating', terms: ['condition', 'how is our gear graded', 'what is a 3 of 5', 'what is a 5 of 5', 'condition guide'] },
    { url: '/pages/trade-in-program', terms: ['trade in', 'sell my gear', 'sell gear', 'cash for gear', 'store credit', 'gear trade'] },
    { url: '/pages/ski-rentals', terms: ['rent skis', 'rent snowboards', 'ski rental', 'rent a', 'season rental', 'ski tune', 'rent boots', 'rental', 'appointment', 'rental appointment', 'no appointment needed'] },
    { url: '/pages/tune-shop', terms: ['tune', 'tuning', 'service', 'edge tune', 'wax', 'bindings service', 'boot tech'] },
    { url: '/pages/shipping-returns', terms: ['shipping', 'returns', 'return policy', 'refund', 'exchange', 'exchange policy'] },
    { url: '/pages/privacy-policy', terms: ['privacy', 'privacy policy', 'data', 'cookies'] },
    { url: '/pages/terms-conditions', terms: ['terms', 'terms and conditions', 'terms of service', 'policies'] },
    { url: '/pages/tech-tips', terms: ['tech tips', 'maintenance', 'care', 'how to clean', 'how to store', 'how to wax'] },
    { url: '/pages/rocker-camber', terms: ['rocker', 'camber', 'rocker camber', 'ski stance', 'rider tips', 'camber profile'] },
    { url: '/pages/adult-ski-size', terms: ['adult size', 'adult sizing', 'size chart', 'adult ski sizing', 'adult snow shoe size'] },
    { url: '/pages/kids-ski-size', terms: ['kids size', 'kids sizing', 'children size', 'kid sizing chart'] },
    { url: '/pages/faq', terms: ['faq', 'frequently asked questions', 'questions', 'help', 'customer support'] },
    { url: '/pages/in-store', terms: ['in store', 'instore', 'store', 'store hours', 'physical store', 'directions', 'location info', 'come in person'] },
    { url: '/pages/our-story', terms: ['used mountain sports', 'local shop', 'about our store', 'colorado springs outdoor', 'store info'] },
    { url: '/pages/privacy-policy', terms: ['security policy', 'legal', 'gdpr'] }
  ];

  const pageTermMatches = (query, term) => {
    if (!query) return false;
    if (query === term) return true;
    if (query.includes(term)) return true;
    const similarity = tokenSimilarity(query, term);
    return similarity >= 0.74;
  };

  const pickPageSearchIntent = (value) => {
    const query = correctSearchSpelling(value);
    if (!query) return null;

    const match = pageSearchIntents.find((intent) => (
      intent.terms.some((term) => pageTermMatches(query, normalizeCategorySearch(term)))
    ));
    return match || null;
  };

  const suggestSearchCorrection = async (query) => {
    try {
      if (!query || query.length < 3) return query;
      const endpoint = new URL('/search/suggest.json', window.location.origin);
      endpoint.searchParams.set('q', query);
      endpoint.searchParams.set('resources[type]', 'query');
      endpoint.searchParams.set('resources[limit]', '5');

      const response = await fetch(endpoint.toString(), {
        headers: { Accept: 'application/json' },
        method: 'GET'
      });
      if (!response.ok) return query;

      const payload = await response.json();
      const queryResource = (payload?.resources?.queries || []).find((item) => normalizeCategorySearch(item?.query) === query);
      const rawSuggestion = queryResource?.suggestions?.[0]?.text || payload?.resources?.results?.[0]?.suggested_text;
      if (!rawSuggestion) return query;
      return normalizeCategorySearch(rawSuggestion);
    } catch (error) {
      return query;
    }
  };

  const categorySearchRedirects = [
    { url: '/collections/all?sort_by=created-descending', patterns: [/\bused\s+(gear|products?|items?)\b/, /\bpre[-\s]?owned\s+(gear|products?|items?)\b/, /\bnew\s+(gear|products?|items?)\b/] },
    { url: '/collections/snow?filter.p.m.catalog.product_family=Snowboard%20Boots', patterns: [/\bsnowboards?\s+boots?\b/, /\bboots?\s+for\s+snowboards?\b/] },
    { url: '/collections/snow?filter.p.m.catalog.product_family=Ski%20Boots', patterns: [/\bski\s+boots?\b/, /\balpine\s+boots?\b/] },
    { url: '/collections/snow?filter.p.m.catalog.product_family=Ski%20Boots&filter.p.m.catalog.product_family=Snowboard%20Boots', patterns: [/\bsnow\s+boots?\b/] },
    { url: '/collections/snow?filter.p.m.catalog.product_family=Bindings&snow_category=ski-bindings', patterns: [/\bski\s+bindings?\b/] },
    { url: '/collections/snow?filter.p.m.catalog.product_family=Bindings&snow_category=snowboard-bindings', patterns: [/\bsnowboards?\s+bindings?\b/] },
    { url: '/collections/snow?filter.p.m.catalog.product_family=Bindings', patterns: [/\bsnow\s+bindings?\b/, /^bindings?$/] },
    { url: '/collections/ski-poles', patterns: [/\bski\s+poles?\b/] },
    { url: '/collections/snow-accessories#snow_accessory_category=helmets', patterns: [/\bsnow\s+helmets?\b/, /\bski\s+helmets?\b/, /\bsnowboards?\s+helmets?\b/] },
    { url: '/collections/snow-accessories#snow_accessory_category=backpacks', patterns: [/\bsnow\s+(?:back)?packs?\b/, /\bski\s+backpacks?\b/, /\bsnowboards?\s+backpacks?\b/, /\bbackcountry\s+backpacks?\b/, /\bairbag\s+(?:back)?packs?\b/, /\bavalanche\s+(?:back)?packs?\b/] },
    { url: '/collections/snow-accessories#snow_accessory_category=goggles', patterns: [/\bsnow\s+goggles?\b/, /\bski\s+goggles?\b/, /\bsnowboards?\s+goggles?\b/, /^goggles?$/] },
    { url: '/collections/snow-accessories', patterns: [/\bski\s+bags?\b/, /\bsnowboards?\s+bags?\b/] },
    { url: '/collections/snow-gloves', patterns: [/\bsnow\s+gloves?\b/, /\bski\s+gloves?\b/, /\bsnowboards?\s+gloves?\b/] },
    { url: '/collections/snowshoes', patterns: [/\bsnow\s+shoes?\b/, /\bsnowshoes?\b/] },
    { url: '/collections/probes', patterns: [/\bavalanche\s+probes?\b/, /\bsnow\s+probes?\b/, /^probes?$/] },
    { url: '/collections/shovels', patterns: [/\bavalanche\s+shovels?\b/, /\bsnow\s+shovels?\b/, /^shovels?$/] },
    { url: '/collections/snow?filter.p.m.catalog.product_family=Avalanche%20Gear', patterns: [/\bavalanche\b/, /\bbeacons?\b/, /\bbackcountry\s+snow\b/, /\bsnow\s+safety\b/] },
    { url: '/collections/splitboards', patterns: [/\bsplitboards?\b/] },
    { url: '/collections/snow?filter.p.m.catalog.product_family=Snowboards', patterns: [/\bsnowboards?\b/, /\bsnow\s+boards?\b/] },
    { url: '/collections/snow?filter.p.m.catalog.product_family=Skis', patterns: [/\bused\s+skis?\b/, /\balpine\s+skis?\b/, /\bskis\b/, /^ski$/] },
    { url: '/collections/mens-clothing?filter.p.m.catalog.product_family=Outerwear&mens_category=jackets', patterns: [/\bmens?\s+(snow\s+|ski\s+)?jackets?\b/, /\bmens?\s+(shells?|outerwear)\b/] },
    { url: '/collections/mens-clothing?filter.p.m.catalog.product_family=Tops&mens_category=shirts', patterns: [/\bmens?\s+(shirts?|tops?|midlayers?|base\s+layers?|fleeces?|hoodies?)\b/] },
    { url: '/collections/mens-clothing?filter.p.m.catalog.product_family=Bottoms&mens_category=shorts', patterns: [/\bmens?\s+shorts?\b/] },
    { url: '/collections/mens-clothing?filter.p.m.catalog.product_family=Bottoms&mens_category=pants', patterns: [/\bmens?\s+(snow\s+|ski\s+)?(pants?|bibs?)\b/] },
    { url: '/collections/mens-clothing?filter.p.m.catalog.product_family=Outerwear&filter.p.m.catalog.product_family=Bottoms', patterns: [/\bmens?\s+snow\s+(gear|clothing|jackets?|pants?|bibs?)\b/] },
    { url: '/collections/womens-clothing?filter.p.m.catalog.product_family=Outerwear&womens_category=jackets', patterns: [/\bwomens?\s+(snow\s+|ski\s+)?jackets?\b/, /\bwomens?\s+(shells?|outerwear)\b/] },
    { url: '/collections/womens-clothing?filter.p.m.catalog.product_family=Tops&womens_category=shirts', patterns: [/\bwomens?\s+(shirts?|tops?|midlayers?|base\s+layers?|fleeces?|hoodies?)\b/] },
    { url: '/collections/womens-clothing?filter.p.m.catalog.product_family=Bottoms&womens_category=shorts', patterns: [/\bwomens?\s+shorts?\b/] },
    { url: '/collections/womens-clothing?filter.p.m.catalog.product_family=Bottoms&filter.p.m.catalog.product_family=Outerwear&womens_category=pants', patterns: [/\bwomens?\s+(snow\s+|ski\s+)?(pants?|bibs?)\b/] },
    { url: '/collections/womens-clothing?filter.p.m.catalog.product_family=Outerwear&filter.p.m.catalog.product_family=Bottoms', patterns: [/\bwomens?\s+snow\s+(gear|clothing|jackets?|pants?|bibs?)\b/] },
    { url: '/collections/kids-clothing?filter.p.m.catalog.product_family=Outerwear&filter.p.m.catalog.product_family=Bottoms', patterns: [/\bkids?\s+snow\s+(gear|clothing|jackets?|pants?|bibs?)\b/] },
    { url: '/collections/clothing-and-footwear?filter.p.m.catalog.product_family=Outerwear&filter.p.m.catalog.product_family=Bottoms', patterns: [/\bsnow\s+(jackets?|pants?|bibs?|clothing)\b/, /\bski\s+(jackets?|pants?|bibs?|clothing)\b/, /\bsnowboards?\s+(jackets?|pants?|bibs?|clothing)\b/] },
    { url: '/collections/mens-clothing?filter.p.m.catalog.product_family=Footwear&mens_category=shoes', patterns: [/\b(?:men'?s|mens?)\s+(?:hiking\s+|running\s+|trail\s+|approach\s+)?(?:shoes?|boots?|sandals?|footwear|trail\s+runners?)\b/] },
    { url: '/collections/womens-clothing?filter.p.m.catalog.product_family=Footwear&womens_category=shoes', patterns: [/\b(?:women'?s|womens?|ladies)\s+(?:hiking\s+|running\s+|trail\s+|approach\s+)?(?:shoes?|boots?|sandals?|footwear|trail\s+runners?)\b/] },
    { url: '/collections/hiking-poles#hiking_category=footwear', patterns: [/\bhiking\s+(boots?|shoes?|footwear)\b/, /\btrail\s+(boots?|shoes?)\b/, /\bshoes?\s+and\s+boots?\b/] },
    { url: '/collections/hiking-poles#hiking_category=packs', patterns: [/\bhiking\s+(packs?|backpacks?)\b/, /\bbackpacking\s+(packs?|backpacks?)\b/, /\bday\s+packs?\b/, /\bbackpacks?\b/] },
    { url: '/collections/hiking-poles', patterns: [/\bhiking\s+poles?\b/, /\btrekking\s+poles?\b/, /\bwalking\s+poles?\b/] },
    { url: '/collections/hiking-poles', patterns: [/\bhiking\s+gear\b/, /\bhike\s+gear\b/] },
    { url: '/collections/tents#camping_category=camp-kitchen-water', patterns: [/\bwater\s+purification\b/, /\bwater\s+filters?\b/, /\bhydration\b/] },
    { url: '/collections/tents#camping_category=camp-kitchen-water', patterns: [/\bcamp\s+stoves?\b/, /\bstoves?\b/, /\bpots?\b/, /\bpans?\b/, /\bcookware\b/] },
    { url: '/collections/tents#camping_category=camp-kitchen-water', patterns: [/\bcamp\s+kitchen\b/, /\bcamping\s+kitchen\b/] },
    { url: '/collections/tents#camping_category=camping', patterns: [/\bcamping\s+gear\b/, /\bcamp\s+gear\b/, /\bcamping\b/] },
    { url: '/collections/tents#camping_category=camping', patterns: [/\btents?\b/, /\bshelters?\b/] },
    { url: '/collections/tents#camping_category=camping', patterns: [/\bsleeping\s+bags?\b/] },
    { url: '/collections/tents#camping_category=camping', patterns: [/\bsleeping\s+pads?\b/] },
    { url: '/collections/tents#camping_category=camping', patterns: [/\bsleeping\b/] },
    { url: '/collections/camp-hike', patterns: [/\bcamp\b/, /\bcamping\b/, /\bhike\b/, /\bhiking\b/] },
    { url: '/collections/climbing#climbing_category=ice-boots', patterns: [/\bice\s+boots?\b/, /\bice\s+climbing\s+boots?\b/] },
    { url: '/collections/climbing#climbing_category=mountaineering-boots', patterns: [/\bmountaineering\s+boots?\b/, /\bmountain\s+boots?\b/] },
    { url: '/collections/climbing#climbing_category=ice-tools', patterns: [/\bice\s+(axes?|tools?)\b/] },
    { url: '/collections/climbing#climbing_category=mountaineering-ice-accessories', patterns: [/\bmountaineering\s+accessor(?:y|ies)\b/, /\bice\s+climbing\s+accessor(?:y|ies)\b/, /\bcrampons?\b/, /\bsnow\s+fluk(?:e|es)?s?\b/, /\bhammer\s+replacements?\b/, /\bantisnow\b/, /\banti[-\s]?snow\b/] },
    { url: '/collections/climbing#climbing_category=mountaineering-ice-climb', patterns: [/\bmountaineering\b/, /\bice\s+climbing\b/] },
    { url: '/collections/climbing#climbing_category=climbing-shoes', patterns: [/\bregular\s+climbing\s+shoes?\b/, /\bclimbing\s+shoes?\b/, /\brock\s+shoes?\b/, /\bapproach\s+shoes?\b/] },
    { url: '/collections/climbing#climbing_category=protection', patterns: [/\bclimbing\s+protection\b/, /\btrad\s+gear\b/, /\bcams?\b/, /\bnuts?\b/, /\bhexes?\b/, /\bquick\s?draws?\b/] },
    { url: '/collections/climbing#climbing_category=climbing-accessories', patterns: [/\bclimbing\s+accessor(?:y|ies)\b/, /\banchor\s+straps?\b/, /\bv[-\s]?thread\b/, /\bteathers?\b/, /\btethers?\b/, /\bgear\s+slings?\b/, /\bascenders?\b/, /\bpulleys?\b/, /\bpullys?\b/, /\bcarabiners?\b/, /\bbelay\b/, /\brappel(l)?ing\b/] },
    { url: '/collections/climbing#climbing_category=rock-climbing', patterns: [/\brock\s+climbing\b/] },
    { url: '/collections/climbing', patterns: [/\bclimbing\b/] },
    { url: '/collections/bike', patterns: [/\bbike\s+helmets?\b/, /\bcycling\s+helmets?\b/, /\bbike\s+shoes?\b/, /\bcycling\s+shoes?\b/, /\bbike\s+(clothing|apparel|jerseys?|shorts?)\b/, /\bcycling\s+(clothing|apparel|jerseys?|shorts?)\b/, /\bbike\s+pedals?\b/, /\bpedals?\b/, /\bdrivetrain\b/, /\bshifting\b/, /\bbike\s+(bags?|pads?|glasses|accessories)\b/, /\bbikes?\b/, /\bcycling\b/] },
    { url: '/collections/water', patterns: [/\bsandals?\b/, /\bwater\s+shoes?\b/, /\bwater\s+footwear\b/, /\bkayaks?\b/, /\bpaddles?\b/, /\bspray\s+skirts?\b/, /\bboats?\b/, /\bboards?\b/, /\bwater\s+gear\b/, /\bwater\b/] },
    { url: '/collections/all?sort_by=created-descending&filter.p.m.catalog.product_family=Outerwear', patterns: [/\b(jackets?|shells?|rain\s+jackets?|puffy|puffies|insulated\s+jackets?)\b/] },
    { url: '/collections/all?sort_by=created-descending&filter.p.m.catalog.product_family=Bottoms', patterns: [/\b(pants?|bibs?|shorts?|skirts?)\b/] },
    { url: '/collections/all?sort_by=created-descending&filter.p.m.catalog.product_family=Tops', patterns: [/\b(tops?|shirts?|midlayers?|fleeces?|hoodies?|sweaters?)\b/] },
    { url: '/collections/all?sort_by=created-descending&filter.p.m.catalog.product_family=Footwear', patterns: [/\b(footwear|shoes?)\b/] },
    { url: '/collections/racks-travel', patterns: [/\bbike\s+racks?\b/, /\bski\s+racks?\b/, /\bsnowboards?\s+racks?\b/, /\bwater\s+sport\s+racks?\b/, /\bvehicle\s+racks?\b/, /\bracks?\b/, /\btravel\b/] },
    { url: '/collections/gloves', patterns: [/\bgloves?\b/] },
    { url: '/collections/skateboards', patterns: [/\bskateboards?\b/] }
  ];

  const preparedCategorySearchRedirects = (() => {
    const redirects = [];
    const pushItem = (item) => {
      if (!item || !item.suggestedUrl) return;
      const term = normalizeCategorySearch(item.label);
      if (term.length < 4) return;
      redirects.push({ term, url: item.suggestedUrl });
      (item.groups || []).forEach(pushItem);
      (item.items || []).forEach(pushItem);
    };

    preparedNavigation.forEach(pushItem);
    return redirects.sort((a, b) => b.term.length - a.term.length);
  })();

  const categoryTermMatches = (query, term) => (
    query === term
    || query.startsWith(`${term} `)
    || query.endsWith(` ${term}`)
    || query.includes(` ${term} `)
    || query.includes(term)
  );

  const findFuzzyCategoryMatch = (query) => {
    const normalized = normalizeCategorySearch(query);
    if (!normalized) return null;

    const scoredCandidates = preparedCategorySearchRedirects.map((redirect) => {
      const score = tokenSimilarity(normalized, redirect.term);
      const isBoundaryMatch = categoryTermMatches(normalized, redirect.term);
      if (isBoundaryMatch) return { ...redirect, score: Math.max(score, 1) };
      return { ...redirect, score };
    }).filter((candidate) => candidate.score >= 0.64);

    if (!scoredCandidates.length) return null;

    scoredCandidates.sort((a, b) => {
      if (b.score !== a.score) return b.score - a.score;
      if (b.term.length !== a.term.length) return b.term.length - a.term.length;
      return b.url.length - a.url.length;
    });

    return scoredCandidates[0].url;
  };

  const addSearchParamIfMissing = (target, name, value) => {
    if (!value) return;
    const currentValues = target.searchParams.getAll(name);
    if (!currentValues.includes(value)) target.searchParams.append(name, value);
  };

  const setSearchParamIfMissing = (target, name, value) => {
    if (!value || target.searchParams.has(name)) return;
    target.searchParams.set(name, value);
  };

  const cleanFilterNumber = (value) => {
    const numeric = Number.parseFloat(String(value || '').replace(/,/g, ''));
    if (!Number.isFinite(numeric) || numeric <= 0) return '';
    return String(Math.round(numeric * 100) / 100).replace(/\.0$/, '');
  };

  const parsePriceIntent = (query) => {
    const betweenMatch = query.match(/\bbetween\s+\$?\s*(\d+(?:\.\d+)?)\s*(?:and|to|-)\s*\$?\s*(\d+(?:\.\d+)?)/);
    if (betweenMatch) {
      const first = cleanFilterNumber(betweenMatch[1]);
      const second = cleanFilterNumber(betweenMatch[2]);
      if (first && second) {
        return {
          min: String(Math.min(Number(first), Number(second))),
          max: String(Math.max(Number(first), Number(second)))
        };
      }
    }

    const underMatch = query.match(/(?:\bunder|\bbelow|\bless\s+than|\bmax(?:imum)?|\bup\s+to|<=|<)\s*\$?\s*(\d+(?:\.\d+)?)/);
    const overMatch = query.match(/(?:\bover|\babove|\bmore\s+than|\bmin(?:imum)?|\bat\s+least|>=|>)\s*\$?\s*(\d+(?:\.\d+)?)/);
    return {
      min: cleanFilterNumber(overMatch?.[1]),
      max: cleanFilterNumber(underMatch?.[1])
    };
  };

  const parseConditionRatingIntent = (query) => { const labels = ["New / Unused","Like New","Lightly Used","Normal Use","Well Loved","Heavily Used","Parts / Display"]; return labels.find(label => query.toLowerCase().includes(label.toLowerCase())) || ''; };

  const parseSizeFilterIntents = (query, target) => {
    const sizeValues = [];
    const urlText = normalizeCategorySearch(`${target.pathname} ${target.searchParams.toString()}`);
    const isFootwearSearch = /\b(boots?|shoes?|footwear)\b/.test(query) || urlText.includes('boots') || urlText.includes('footwear');
    const isLengthSearch = /\b(skis?|snowboards?|snow\s+boards?|poles?|alpine)\b/.test(query) && !/\bboots?\b/.test(query);
    const isClothingSearch = /\b(clothing|apparel|jackets?|shells?|puffy|puffies|pants?|bibs?|shorts?|skirts?|tops?|shirts?|midlayers?|fleeces?|hoodies?|helmets?|gloves?)\b/.test(query)
      || urlText.includes('clothing') || urlText.includes('outerwear') || urlText.includes('bottoms') || urlText.includes('tops');

    if (isLengthSearch) {
      const lengthMatch = query.match(/\b(\d{2,3})\s*cm\b/);
      if (lengthMatch) sizeValues.push(`Length ${Number.parseInt(lengthMatch[1], 10)} cm`);
    }

    if (isFootwearSearch) {
      const mondoMatch = query.match(/\bmondo\s*(\d{2}(?:\.\d)?)\b/)
        || query.match(/\b(\d{2}(?:\.\d)?)\s*(?:mondo|mp)\b/)
        || query.match(/\b(\d{2}\.\d)\s*(?:ski\s+boots?|snowboard\s+boots?|boots?)\b/);
      if (mondoMatch) sizeValues.push(`Mondo ${mondoMatch[1]}`);

      const euMatch = query.match(/\beu\s*(\d{2}(?:\.\d)?)\b/)
        || query.match(/\bsize\s*(\d{2}(?:\.\d)?)\s*(?:eu|climbing\s+shoes?|shoes?)\b/)
        || query.match(/\b(\d{2}(?:\.\d)?)\s*(?:eu|climbing\s+shoes?)\b/)
        || query.match(/\b(?:climbing\s+shoes?|shoes?).*?\bsize\s*(\d{2}(?:\.\d)?)\b/)
        || query.match(/\bsize\s*(\d{2}(?:\.\d)?)\b/);
      if (euMatch) {
        const euSize = Number.parseFloat(euMatch[1]);
        if (euSize >= 30 && euSize <= 50) sizeValues.push(`EU Shoe ${euMatch[1]}`);
      }

      const usMatch = query.match(/\bus\s*(?:shoe\s*)?(?:size\s*)?(\d{1,2}(?:\.\d)?)\b/)
        || query.match(/\bsize\s*(\d{1,2}(?:\.\d)?)\s*(?:us|shoe|shoes?|boots?)\b/)
        || query.match(/\b(?:boots?|shoes?).*?\bsize\s*(\d{1,2}(?:\.\d)?)\b/);
      if (usMatch) {
        const usSize = Number.parseFloat(usMatch[1]);
        if (usSize >= 1 && usSize <= 16) sizeValues.push(`US Shoe ${usMatch[1]}`);
      }
    }

    if (isClothingSearch) {
      const clothingSizes = [
        { value: 'XXL', patterns: [/\bxxl\b/, /\b2xl\b/, /\bextra\s+extra\s+large\b/] },
        { value: 'XL', patterns: [/\bxl\b/, /\bextra\s+large\b/] },
        { value: 'Large', patterns: [/\blarge\b/, /\blg\b/] },
        { value: 'Medium', patterns: [/\bmedium\b/, /\bmed\b/] },
        { value: 'Small', patterns: [/\bsmall\b/, /\bsm\b/] },
        { value: 'XS', patterns: [/\bxs\b/, /\bextra\s+small\b/] }
      ];
      clothingSizes.forEach((size) => {
        if (size.patterns.some((pattern) => pattern.test(query))) sizeValues.push(size.value);
      });
    }

    return [...new Set(sizeValues)];
  };

  const knownVendorFilters = [
    ['arc teryx', "Arc'teryx"],
    ['arcteryx', "Arc'teryx"],
    ['atomic', 'Atomic'],
    ['black diamond', 'Black Diamond'],
    ['burton', 'Burton'],
    ['dynafit', 'Dynafit'],
    ['elan', 'Elan'],
    ['fischer', 'Fischer'],
    ['k2', 'K2'],
    ['la sportiva', 'La Sportiva'],
    ['mammut', 'Mammut'],
    ['marker', 'Marker'],
    ['marmot', 'Marmot'],
    ['north face', 'The North Face'],
    ['oboz', 'Oboz'],
    ['osprey', 'Osprey'],
    ['patagonia', 'Patagonia'],
    ['petzl', 'Petzl'],
    ['rei', 'REI'],
    ['ride', 'Ride'],
    ['rossignol', 'Rossignol'],
    ['salomon', 'Salomon'],
    ['scarpa', 'Scarpa'],
    ['thule', 'Thule'],
    ['volkl', 'Volkl']
  ];

  const parseVendorFilterIntent = (query) => {
    const match = knownVendorFilters.find(([term]) => {
      const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\\ /g, '\\s+');
      return new RegExp(`\\b${escaped}\\b`).test(query);
    });
    return match?.[1] || '';
  };

  const applySearchFilterIntentsToCategoryUrl = (url, query) => {
    if (!url || !query) return url;

    const target = new URL(url, window.location.origin);

    const priceIntent = parsePriceIntent(query);
    setSearchParamIfMissing(target, 'filter.v.price.gte', priceIntent.min);
    setSearchParamIfMissing(target, 'filter.v.price.lte', priceIntent.max);

    addSearchParamIfMissing(target, 'filter.p.m.custom.condition_label', parseConditionRatingIntent(query));
    parseSizeFilterIntents(query, target).forEach((sizeValue) => {
      addSearchParamIfMissing(target, 'filter.p.m.catalog.size_display', sizeValue);
    });
    addSearchParamIfMissing(target, 'filter.p.vendor', parseVendorFilterIntent(query));

    return target.pathname + target.search + target.hash;
  };

  const categoryRedirectForSearch = (value) => {
    const query = correctSearchSpelling(value);
    const filterQuery = correctSearchSpelling(value, { preserveFilterChars: true });
    if (!query) return '';

    const manualMatch = categorySearchRedirects.find((redirect) => (
      redirect.patterns.some((pattern) => pattern.test(query))
    ));
    if (manualMatch) return applySearchFilterIntentsToCategoryUrl(manualMatch.url, filterQuery);

    const navigationMatch = preparedCategorySearchRedirects.find((redirect) => categoryTermMatches(query, redirect.term));
    if (navigationMatch) return applySearchFilterIntentsToCategoryUrl(navigationMatch.url, filterQuery);

    return applySearchFilterIntentsToCategoryUrl(findFuzzyCategoryMatch(query) || '', filterQuery);
  };

  const categoryDestinationKey = (href) => {
    if (!href) return '';
    const url = new URL(href, window.location.origin);
    const categoryParams = [...url.searchParams].filter(([key]) => (
      key.endsWith('.product_family') || key.endsWith('_category')
    )).sort(([a, av], [b, bv]) => a.localeCompare(b) || av.localeCompare(bv));
    return `${url.pathname.replace(/\/+$/, '')}?${new URLSearchParams(categoryParams)}${url.hash}`;
  };

  const syncHeaderCategoryMenus = () => {
    if (!preparedNavigation.length) return;
    const menuSources = preparedNavigation.flatMap((department) => [department, ...(department.groups || [])]);
    document.querySelectorAll('.gear-type-quick-filter').forEach((filter) => {
      const title = normalizeCategorySearch(filter.querySelector('.gear-type-quick-filter__title')?.textContent).replace(/ categories$/, '');
      const source = menuSources.find((item) => normalizeCategorySearch(item.label) === title);
      if (!source) return;

      const entries = [];
      const seen = new Set();
      const addEntry = (item) => {
        if (!item.suggestedUrl) return;
        const key = categoryDestinationKey(item.suggestedUrl);
        if (seen.has(key)) return;
        seen.add(key);
        entries.push({ ...item, key });
      };
      if (title === 'shop all') {
        preparedNavigation.filter((item) => item !== source).forEach(addEntry);
      } else if (source.groups?.length) {
        source.groups.forEach((group) => {
          const children = group.items || [];
          if (!children.some((item) => categoryDestinationKey(item.suggestedUrl) === categoryDestinationKey(group.suggestedUrl))) addEntry(group);
          children.forEach(addEntry);
        });
      } else {
        (source.items || []).forEach(addEntry);
      }
      if (!entries.length) return;

      const buttonList = filter.querySelector('.gear-type-quick-filter__buttons');
      if (!buttonList) return;
      const existing = [...buttonList.children];
      const labelOf = (button) => normalizeCategorySearch(button.querySelector('span')?.textContent || button.dataset.filterValue || button.textContent);
      const keyOf = (button) => categoryDestinationKey(button.getAttribute('href') || button.dataset.gearPreviewLink);
      const allButton = existing.find((button) => (
        button.classList.contains('gear-type-quick-filter__button--all')
        || /^all\b/.test(labelOf(button))
        || (labelOf(button) === normalizeCategorySearch(source.label) && keyOf(button) === categoryDestinationKey(source.suggestedUrl))
      ));
      const ordered = allButton ? [allButton] : [];
      const candidates = existing.filter((button) => button !== allButton);
      entries.forEach((entry) => {
        // Reuse existing nodes so native and virtual filter listeners keep working.
        let button = candidates.find((item) => keyOf(item) === entry.key && !ordered.includes(item))
          || candidates.find((item) => labelOf(item) === normalizeCategorySearch(entry.label) && !ordered.includes(item));
        if (!button) {
          button = document.createElement('a');
          button.className = 'gear-type-quick-filter__button';
          button.href = entry.suggestedUrl;
          button.dataset.headerCategoryLink = 'true';
          button.append(document.createElement('span'));
        }
        const label = button.querySelector('span');
        if (label) label.textContent = entry.label;
        if (button.dataset.headerCategoryLink) {
          const active = entry.key === categoryDestinationKey(window.location.href);
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        }
        ordered.push(button);
      });
      buttonList.replaceChildren(...ordered);

      const preview = filter.querySelector('.gear-type-quick-filter__preview');
      const previewSeen = new Set();
      preview?.querySelectorAll('a, button').forEach((button) => {
        if (/^all\b/.test(labelOf(button))) return;
        const entry = entries.find((item) => item.key === keyOf(button))
          || entries.find((item) => normalizeCategorySearch(item.label) === labelOf(button));
        if (!entry || previewSeen.has(entry.key)) button.remove();
        else previewSeen.add(entry.key);
      });
      filter.dataset.headerCategories = source.label;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncHeaderCategoryMenus, { once: true });
  } else {
    syncHeaderCategoryMenus();
  }
  window.addEventListener('load', syncHeaderCategoryMenus, { once: true });
  window.addEventListener('hashchange', syncHeaderCategoryMenus);
  window.addEventListener('popstate', syncHeaderCategoryMenus);
  document.addEventListener('shopify:section:load', syncHeaderCategoryMenus);

  const buildSearchFallbackUrl = (form, query) => {
    const fallback = form.dataset.searchFallbackUrl || '/search?type=product,page,article&options%5Bprefix%5D=last';
    const fallbackUrl = new URL(fallback, window.location.origin);
    const normalizedQuery = normalizeCategorySearch(query);
    if (normalizedQuery) {
      fallbackUrl.searchParams.set('q', normalizedQuery);
    }
    return fallbackUrl.pathname + fallbackUrl.search + fallbackUrl.hash;
  };

  const resolveSmartSearchTarget = async (form, value) => {
    const query = String(value || '').trim().replace(/\s+/g, ' ');
    if (!query) return null;
    // Resolve categories from the rendered menu so new collection assignments stay in sync.
    // Never discard model names, sizes, brands, or other words in a product search.
    const normalizeIntent = (text) => String(text || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[’']/g, '').replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
    const aliases = {
      'ski': 'skis', 'ski boot': 'ski boots', 'ski pole': 'ski poles', 'ski binding': 'ski bindings',
      'snowboard': 'snowboards', 'snow board': 'snowboards', 'snow boards': 'snowboards',
      'snowboard boot': 'snowboard boots', 'snowboard binding': 'snowboard bindings',
      'snowshoe': 'snowshoes', 'splitboard': 'splitboards', 'climbing shoe': 'climbing shoes',
      'rock climbing shoes': 'climbing shoes', 'mountaineering boot': 'mountaineering boots',
      'ice tool': 'ice tools', 'ice axe': 'ice tools', 'ice axes': 'ice tools', 'crampon': 'crampons',
      'avalanche gear': 'avalanche safety', 'nordic skiing': 'cross country skiing',
      'cross country': 'cross country skiing', 'telemark': 'telemark skiing',
      'camp and hiking': 'camp and hike', 'camping gear': 'camping gear',
      'hiking shoes': 'hiking footwear', 'hiking boots': 'hiking footwear',
      'mens clothing': 'mens', 'men clothing': 'mens', 'womens clothing': 'womens',
      'women clothing': 'womens', 'kids clothing': 'kids clothing',
      'gloves': 'gloves and mitts', 'mittens': 'gloves and mitts', 'sunglass': 'sunglasses',
      'ski helmet': 'helmets', 'ski helmets': 'helmets', 'snowboard helmets': 'helmets',
      'pet gear': 'pets', 'racks': 'racks and travel'
    };
    const intent = normalizeIntent(query);
    const categoryIntent = aliases[intent] || intent;
    const menuLinks = Array.from(document.querySelectorAll('[aria-label="Main menu"] a[href], [data-prepared-nav] a[href]'));
    const category = menuLinks.find((link) => {
      const href = link.getAttribute('href') || '';
      return href.startsWith('/collections/') && normalizeIntent(link.textContent) === categoryIntent;
    });
    if (category) {
      const target = new URL(category.getAttribute('href'), window.location.origin);
      target.searchParams.set('filter.v.availability', '1');
      return target.pathname + target.search + target.hash;
    }
    const serviceOverrides = { 'ski tune': '/pages/tune-shop', 'ski tuning': '/pages/tune-shop', 'snowboard tune': '/pages/tune-shop', 'snowboard tuning': '/pages/tune-shop' };
    if (serviceOverrides[intent]) return serviceOverrides[intent];
    const page = pageSearchIntents.find((item) => item.terms.some((term) => normalizeIntent(term) === intent));
    if (page) return page.url;
    const target = new URL(form.getAttribute('action') || '/search', window.location.origin);
    target.searchParams.set('q', query);
    target.searchParams.set('type', 'product');
    target.searchParams.set('options[prefix]', 'last');
    target.searchParams.set('options[unavailable_products]', 'last');
    target.searchParams.set('sort_by', 'relevance');
    return target.pathname + target.search;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    let actionUrl;
    try {
      actionUrl = new URL(form.getAttribute('action') || '/search', window.location.origin);
    } catch (error) {
      return;
    }
    if (actionUrl.pathname !== '/search' && !form.classList.contains('site-search')) return;

    // Filter forms submit their own selected facets through the browser.
    if (form.querySelector('[name^="filter."]')) return;
    const searchInput = form.querySelector('input[name="q"], input[type="search"]');
    const searchValue = searchInput?.value || '';
    if (!normalizeCategorySearch(searchValue)) return;

    event.preventDefault();
    const redirectUrl = await resolveSmartSearchTarget(form, searchValue);
    if (!redirectUrl) return;

    window.location.href = redirectUrl;
  });

  const readyPreparedUrls = new Set([
    '/',
    '/blogs/news',
    '/cart',
    '/checkout',
    '/pages/adult-ski-size',
    '/pages/condition-rating',
    '/pages/contact',
    '/pages/in-store',
    '/pages/kids-ski-size',
    '/pages/our-story',
    '/pages/privacy-policy',
    '/pages/rocker-camber',
    '/pages/shipping-returns',
    '/pages/ski-rentals',
    '/pages/tech-tips',
    '/pages/terms-conditions',
    '/pages/trade-in-program',
    '/pages/tune-shop',
    '/products/gearonimo-gift-card',
    '/collections/backcountry-ski-boots',
    '/collections/backcountry-snow-gear',
    '/collections/backpacks',
    '/collections/bike',
    '/collections/camp-hike',
    '/collections/camp-kitchen-water',
    '/collections/canyoneering',
    '/collections/climbing',
    '/collections/climbing-hardwear-protection',
    '/collections/climbing-shoes',
    '/collections/clothing-and-footwear',
    '/collections/frontpage',
    '/collections/gloves',
    '/collections/hiking-gear',
    '/collections/ice-climbing',
    '/collections/kids-clothing',
    '/collections/mens-clothing',
    '/collections/mens-footwear',
    '/collections/more-gear',
    '/collections/mountaineering',
    '/collections/mountaineering-crampons',
    '/collections/other-backcountry-gear',
    '/collections/other-camp-hike-gear',
    '/collections/other-gear',
    '/collections/other-sleeping-gear',
    '/collections/racks-travel',
    '/collections/rentals',
    '/collections/rock-climbing-accessories',
    '/collections/sale-gear',
    '/collections/all',
    '/collections/all?sort_by=created-descending',
    '/collections/skateboards',
    '/collections/skis',
    '/collections/sleeping',
    '/collections/snow',
    '/collections/snow-accessories',
    '/collections/snow-boots',
    '/collections/snow-gloves',
    '/collections/snowboard-boots',
    '/collections/snowboards',
    '/collections/snowshoes',
    '/collections/tents',
    '/collections/used-skis',
    '/collections/used-snowboards',
    '/collections/water',
    '/collections/womens-clothing'
  ]);

  const isReadyPreparedUrl = (url) => {
    if (!url) return false;
    if (readyPreparedUrls.has(url)) return true;
    if (url.startsWith('/collections/') || url.startsWith('/pages/') || url.startsWith('/products/') || url.startsWith('/blogs/')) return true;
    return url.startsWith('/collections/all?');
  };

  const preparedButton = (label, className, suggestedUrl) => {
    if (isReadyPreparedUrl(suggestedUrl)) {
      const link = document.createElement('a');
      link.href = suggestedUrl;
      link.className = className;
      link.textContent = label;
      return link;
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.dataset.inertLink = 'true';
    if (suggestedUrl) button.dataset.preparedUrl = suggestedUrl;
    button.textContent = label;
    return button;
  };

  let preparedPointer = null;
  const cancelPreparedDropdownClose = (item) => {
    if (!item) return;
    window.clearTimeout(item._preparedCloseTimer);
    item._preparedCloseTimer = null;
  };

  const closePreparedDropdown = (item) => {
    if (!item) return;
    cancelPreparedDropdownClose(item);
    item.classList.remove('is-open');
    item.querySelector('.primary-nav__link')?.setAttribute('aria-expanded', 'false');
  };

  const closePreparedDropdowns = (currentItem) => {
    document.querySelectorAll('.primary-nav__item.is-open').forEach((item) => {
      if (item === currentItem) return;
      closePreparedDropdown(item);
    });
  };

  const openPreparedDropdown = (item) => {
    if (!item) return;
    cancelPreparedDropdownClose(item);
    closePreparedDropdowns(item);
    item.classList.add('is-open');
    item.querySelector('.primary-nav__link')?.setAttribute('aria-expanded', 'true');
  };

  const isPointerInsideElement = (element, event) => {
    if (!element || typeof event?.clientX !== 'number' || typeof event?.clientY !== 'number') return false;
    const rect = element.getBoundingClientRect();
    return (
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    );
  };

  const isPointerInsidePreparedItem = (item, event) => {
    const dropdown = item?.querySelector('.primary-nav__dropdown');
    if (isPointerInsideElement(item, event) || isPointerInsideElement(dropdown, event)) return true;
    if (!item || !dropdown || !event) return false;
    const trigger = item.getBoundingClientRect();
    const panel = dropdown.getBoundingClientRect();
    const gap = panel.top - trigger.bottom;
    if (gap <= 0 || panel.width <= 0 || event.clientY < trigger.bottom || event.clientY > panel.top) return false;
    // Protect the diagonal route from the department into its full-width panel.
    const progress = (event.clientY - trigger.bottom) / gap;
    const left = trigger.left + (panel.left - trigger.left) * progress - 12;
    const right = trigger.right + (panel.right - trigger.right) * progress + 12;
    return event.clientX >= left && event.clientX <= right;
  };

  const schedulePreparedDropdownClose = (item, event) => {
    if (!item) return;
    if (event && Number.isFinite(event.clientX) && Number.isFinite(event.clientY)) {
      preparedPointer = { clientX: event.clientX, clientY: event.clientY };
    }
    if (item.matches(':focus-within') || isPointerInsidePreparedItem(item, preparedPointer)) {
      cancelPreparedDropdownClose(item);
      return;
    }
    if (item._preparedCloseTimer != null) return;
    item._preparedCloseTimer = window.setTimeout(() => {
      item._preparedCloseTimer = null;
      if (item.matches(':focus-within') || isPointerInsidePreparedItem(item, preparedPointer)) return;
      closePreparedDropdown(item);
    }, 350);
  };

  const closePreparedDropdownsOutsidePointer = (event) => {
    if (event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
    preparedPointer = { clientX: event.clientX, clientY: event.clientY };
    document.querySelectorAll('.primary-nav__item.is-open').forEach((item) => {
      schedulePreparedDropdownClose(item, event);
    });
  };

  const renderDesktopNavigation = (container) => {
    container.innerHTML = '';
    preparedNavigation.forEach((item, index) => {
      const hasDropdown = Array.isArray(item.groups) && item.groups.length > 0;
      const navItem = document.createElement('div');
      navItem.className = `primary-nav__item${index === 0 ? ' primary-nav__item--featured' : ''}${hasDropdown ? ' has-dropdown' : ''}`;

      const topButton = preparedButton(item.label, 'primary-nav__link', item.suggestedUrl);
      if (hasDropdown) {
        topButton.classList.add('primary-nav__link--toggle');
        topButton.setAttribute('aria-haspopup', 'true');
        topButton.setAttribute('aria-expanded', 'false');
        topButton.addEventListener('focus', () => {
          if (navItem._preparedSuppressFocusOpen) {
            navItem._preparedSuppressFocusOpen = false;
            return;
          }
          openPreparedDropdown(navItem);
        });
        topButton.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          closePreparedDropdown(navItem);
          topButton.blur();
        });
        if (topButton.tagName === 'BUTTON') {
          topButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            openPreparedDropdown(navItem);
          });
        }
      }
      navItem.append(topButton);

      if (hasDropdown) {
        const dropdown = document.createElement('div');
        dropdown.className = `primary-nav__dropdown${item.groups.length > 3 ? ' primary-nav__dropdown--wide' : ''}`;

        item.groups.forEach((group) => {
          const groupColumn = document.createElement('section');
          groupColumn.className = 'primary-nav__group';

          groupColumn.append(preparedButton(group.label, 'primary-nav__dropdown-heading', group.suggestedUrl));

          if (Array.isArray(group.items) && group.items.length) {
            const list = document.createElement('div');
            list.className = 'primary-nav__dropdown-list';
            group.items.forEach((child) => {
              list.append(preparedButton(child.label, 'primary-nav__dropdown-link', child.suggestedUrl));
            });
            groupColumn.append(list);
          }

          dropdown.append(groupColumn);
        });

        navItem.append(dropdown);

        dropdown.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          navItem._preparedSuppressFocusOpen = true;
          closePreparedDropdown(navItem);
          topButton.focus();
        });

        navItem.addEventListener('pointerenter', (event) => {
          if (event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
          openPreparedDropdown(navItem);
        });

        navItem.addEventListener('pointerleave', (event) => {
          if (event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
          schedulePreparedDropdownClose(navItem, event);
        });

        navItem.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (navItem.matches(':focus-within') || navItem.matches(':hover')) return;
            closePreparedDropdown(navItem);
          }, 0);
        });
      }

      container.append(navItem);
    });
  };

  const renderMobileNavigation = (container) => {
    container.innerHTML = '';
    preparedNavigation.forEach((item) => {
      const hasDropdown = Array.isArray(item.groups) && item.groups.length > 0;
      if (!hasDropdown) {
        container.append(preparedButton(item.label, 'mobile-menu__link mobile-menu__link--single', item.suggestedUrl));
        return;
      }

      const details = document.createElement('details');
      details.className = 'mobile-menu__group';
      const summary = document.createElement('summary');
      summary.textContent = item.label;
      details.append(summary);

      const body = document.createElement('div');
      body.className = 'mobile-menu__group-body';
      body.append(preparedButton(`All ${item.label}`, 'mobile-menu__heading', item.suggestedUrl));
      item.groups.forEach((group) => {
        const subgroup = document.createElement('div');
        subgroup.className = 'mobile-menu__subgroup';
        subgroup.append(preparedButton(group.label, 'mobile-menu__heading', group.suggestedUrl));

        if (Array.isArray(group.items) && group.items.length) {
          group.items.forEach((child) => {
            subgroup.append(preparedButton(child.label, 'mobile-menu__link', child.suggestedUrl));
          });
        }

        body.append(subgroup);
      });

      details.append(body);
      container.append(details);
    });
  };

  document.querySelectorAll('[data-prepared-nav]').forEach((container) => {
    if (!preparedNavigation.length) return;
    if (container.dataset.preparedNav === 'mobile') {
      renderMobileNavigation(container);
    } else {
      renderDesktopNavigation(container);
    }
  });

  document.addEventListener('pointermove', closePreparedDropdownsOutsidePointer, { passive: true });

  const updateCount = (count) => {
    countNodes.forEach((node) => {
      node.textContent = count || 0;
    });
  };

  const lineUrl = (item) => {
    if (item.url) return item.url;
    if (item.handle) return `/products/${item.handle}`;
    return '/collections/all';
  };

  const updateDrawerTotals = (cart, shipping = null) => {
    if (!drawerTotals || !drawerSubtotal || !drawerShipping) return;
    const shippingEstimate = shipping ? Number(shipping.amount) : 0;
    const largeItemCount = shippingEstimate / 4000;
    const shippingLabel = drawerTotals.querySelector('[data-cart-drawer-shipping-label]');
    const total = drawerTotals.querySelector('[data-cart-drawer-total]');
    const note = drawerTotals.querySelector('[data-cart-drawer-tax-note]');
    const hasShippableItems = (cart.items || []).some(item => item.requires_shipping !== false && Number(item.product_id) !== 8068891344944);
    const hasRental = (cart.items || []).some(item => Number(item.product_id) === 8068891344944);
    const hasUnverifiedShipping = shipping ? shipping.unknown : hasShippableItems;
    const shippingDetails = drawerTotals.querySelector('.shipping-summary__details');
    if (shippingDetails) shippingDetails.hidden = !hasShippableItems;
    drawerTotals.hidden = !cart.items.length;
    if(!cart.items.length)drawerTotals.querySelector('.eno-bag-savings')?.remove();
    drawerSubtotal.textContent = money(cart.total_price);
    drawerShipping.textContent = hasUnverifiedShipping ? 'Confirmed at checkout' : (shippingEstimate > 0 ? money(shippingEstimate) : (hasRental ? 'Free pickup' : 'Not required'));
    drawerShipping.hidden = false;
    if (shippingLabel) shippingLabel.textContent = largeItemCount > 0 ? 'Estimated shipping · ' + largeItemCount + (largeItemCount === 1 ? ' large item' : ' large items') : (hasRental && !hasShippableItems ? 'In-store pickup' : 'Estimated shipping');
    if (total) {
      total.textContent = money(Number(cart.total_price) + (hasUnverifiedShipping ? 0 : shippingEstimate));
      const label = total.parentElement.querySelector('strong');
      if (label && label !== total) label.textContent = hasUnverifiedShipping ? 'Items before shipping & tax' : 'Estimated total before tax';
    }
    if (note) note.textContent = hasUnverifiedShipping ? 'Standard gear ships free; oversized gear $40 per item (per pair of skis). Enter shipping information at checkout to see your final total. Lower 48 only.' : hasShippableItems ? 'Lower 48 only. Shipping estimate included. Enter shipping information at checkout to see your final total.' : (hasRental ? 'Choose Pickup at checkout. Rentals are pickup only in Colorado Springs, with no shipping charge. Tax calculated at checkout.' : 'No shipping required. Tax calculated at checkout.');
  };

  const renderCart = async () => {
    if (!drawerContent) return;
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    updateCount(cart.item_count);
    // Use the same Liquid calculation as the bag page, including product tags and shipping notes.
    let shipping = null;
    try {
      const response = await fetch('/cart?section_id=main-cart', {cache:'no-store'});
      if (!response.ok) throw new Error('Shipping summary unavailable');
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = JSON.parse(document.querySelector('[data-gearonimo-cart-shipping]').textContent);
      if (data.count === cart.item_count && data.total === cart.total_price) shipping = data;
    } catch (_) { /* Never promise free shipping when the classification cannot be read. */ }
    updateDrawerTotals(cart, shipping);

    if (!cart.items.length) {
      drawerContent.innerHTML = `
        <div class="cart-drawer__empty">
          <p>Your bag is empty.</p>
          <a class="button button--primary" href="/collections/all">Shop gear</a>
        </div>
      `;
      return;
    }

    drawerContent.innerHTML = cart.items.map((item) => {
      const url = lineUrl(item);
      const title = safe(item.product_title || item.title);
      const variantOptions = (item.options_with_values || []).filter(option => option.value && option.value !== 'Default Title');
      const variant = variantOptions.length
        ? '<div class="cart-drawer__item-options">' + variantOptions.map(option => '<p style="margin:4px 0"><strong>' + safe(option.name) + ':</strong> ' + safe(displayOptionValue(option.value)) + '</p>').join('') + '</div>'
        : (item.variant_title && item.variant_title !== 'Default Title' ? '<p><strong>Option:</strong> ' + safe(item.variant_title) + '</p>' : '');
      const properties = Object.entries(item.properties || {}).filter(([key, value]) => (
        value && !String(key).startsWith('__')
      ));
      const propertiesHtml = properties.length ? `
        <dl class="cart-item-properties">
          ${properties.map(([key, value]) => `<div><dt>${safe(key)}</dt><dd>${safe(value)}</dd></div>`).join('')}
        </dl>
      ` : '';
      const escapedUrl = safe(url);
      return `
        <article class="cart-drawer__item">
          <a class="cart-drawer__item-image" href="${escapedUrl}" data-inert-link data-prepared-url="${escapedUrl}">
            ${item.image ? `<img src="${item.image}" alt="${title}" loading="lazy">` : ''}
          </a>
          <div class="cart-drawer__item-body">
            <h3><a href="${escapedUrl}" data-inert-link data-prepared-url="${escapedUrl}">${title}</a></h3>
            ${variant}
            ${propertiesHtml}
            <p data-eno-cart-price>${money(item.final_line_price)} <small style="display:block;margin-top:2px;font-size:0.75rem;font-weight:400;">+ taxes</small></p>
            <div class="cart-drawer__item-actions">
              <a href="${escapedUrl}" data-inert-link data-prepared-url="${escapedUrl}">View product</a>
              <a href="/cart/change?id=${encodeURIComponent(item.key)}&quantity=0">Remove</a>
            </div>
          </div>
        </article>
      `;
    }).join('');
    document.dispatchEvent(new CustomEvent('gearonimo:sale-cart',{detail:cart}));
  };
  document.addEventListener('gearonimo:sale-boundary',()=>{if(drawer&&!drawer.hidden)renderCart();});

  const quickAddStyle = document.createElement('style');
  quickAddStyle.textContent = `
    .product-card:has(.product-card__quick-add) { position:relative; }
    .product-card:has(.product-card__quick-add) .product-card__body { padding-bottom:52px; }
    .product-card .product-card__quick-add { position:absolute; right:8px; bottom:8px; z-index:5; display:grid; place-items:center; width:40px; height:40px; min-width:40px; padding:0; border:0; border-radius:50%; background:transparent; color:#EA4600; cursor:pointer; }
    .product-card .product-card__quick-add:hover, .product-card .product-card__quick-add:focus-visible { background:#000; color:#EA4600; }
    .product-card .product-card__quick-add:focus-visible { outline:2px solid #EA4600; outline-offset:2px; }
    .product-card__quick-add:disabled { opacity:.5; cursor:wait; }
    .product-card__quick-dialog { box-sizing:border-box; width:min(480px,calc(100vw - 28px)); max-height:calc(100dvh - 32px); margin:auto; overflow:auto; padding:0; border:1px solid #e2d5c5; border-radius:22px; background:#fffaf3; color:#24201b; box-shadow:0 24px 80px #0005; cursor:auto; }
    .product-card__quick-dialog::backdrop { background:rgba(24,22,19,.52); }
    .product-card__quick-header { position:relative; padding:26px 28px 24px; border-top:5px solid #ea4600; background:#252522; color:#fffaf3; }
    .product-card__quick-eyebrow { display:block; margin-bottom:12px; color:#ffab71; font-size:11px; line-height:1.3; font-weight:800; letter-spacing:.16em; text-transform:uppercase; }
    .product-card__quick-dialog h3 { margin:0 28px 8px 0; color:#fffaf3; font-size:29px; line-height:1.12; letter-spacing:-.025em; font-weight:800; }
    .product-card__quick-header p { margin:0; color:#ddd4c9; font-size:14px; line-height:1.4; }
    .product-card__quick-dialog [data-card-quick-close] { position:absolute; top:13px; right:14px; display:grid; place-items:center; width:36px; height:36px; padding:0; border:1px solid #ffffff35; border-radius:50%; background:#ffffff0d; color:#fff; font-size:25px; line-height:1; cursor:pointer; }
    .product-card__quick-dialog [data-card-quick-close]:hover { background:#ea4600; border-color:#ea4600; }
    .product-card__quick-content { padding:24px 28px 28px; }
    .product-card__quick-product { display:flex; align-items:center; gap:16px; margin-bottom:24px; padding-bottom:22px; border-bottom:1px solid #e7dccf; }
    .product-card__quick-image { flex:0 0 76px; width:76px; height:88px; object-fit:contain; padding:7px; box-sizing:border-box; background:white; border:1px solid #e8dfd4; border-radius:12px; }
    .product-card__quick-vendor { display:block; margin-bottom:5px; color:#9b431c; font-size:10px; line-height:1.3; font-weight:800; letter-spacing:.1em; text-transform:uppercase; }
    .product-card__quick-product p { margin:0; color:#24201b; font-size:15px; font-weight:750; line-height:1.4; }
    .product-card__quick-dialog label { display:grid; gap:9px; color:#51483e; font-size:12px; font-weight:800; letter-spacing:.04em; }
    .product-card__quick-dialog select { appearance:none; box-sizing:border-box; width:100%; min-height:54px; padding:14px 42px 14px 16px; border:1.5px solid #cdb79f; border-radius:12px; background-color:#fff; background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'%3E%3Cpath d='m5 7 5 5 5-5' fill='none' stroke='%23c6450d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E"); background-repeat:no-repeat; background-position:right 14px center; color:#24201b; font:inherit; font-size:15px; font-weight:600; letter-spacing:0; cursor:pointer; }
    .product-card__quick-dialog select:invalid { color:#75695c; }
    .product-card__quick-dialog select:hover { border-color:#ea4600; }
    .product-card__quick-dialog select option { background:#fffaf3; color:#24201b; }
    .product-card__quick-dialog form > button { display:flex; align-items:center; justify-content:center; gap:12px; width:100%; min-height:52px; margin-top:20px; padding:14px 20px; border:0; border-radius:999px; background:#ea4600; color:#fff; box-shadow:0 5px 14px #ea460026; font-size:16px; line-height:1.3; font-weight:800; cursor:pointer; }
    .product-card__quick-dialog form > button > span { font-size:24px; font-weight:500; line-height:1; }
    .product-card__quick-dialog form > button:hover { background:#cc3d00; }
    .product-card__quick-dialog form > button:disabled { opacity:.6; cursor:wait; }
    .product-card__quick-dialog :is(button,select):focus-visible { outline:3px solid #ea4600; outline-offset:3px; }
    .product-card__quick-dialog [data-card-quick-error] { margin:14px 0 0; color:#a32600; font-size:14px; line-height:1.4; }
    @media(max-width:480px) { .product-card__quick-header { padding:22px; } .product-card__quick-content { padding:20px 22px 24px; } .product-card__quick-dialog h3 { font-size:26px; } }

    .product-card__quick-dialog .product-card__choice-label { margin:0 0 9px; font-size:12px; font-weight:800; color:#51483e; }
    .product-card__choice-picker { border:1.5px solid #cdb79f; border-radius:13px; background:#fff; overflow:hidden; }
    .product-card__choice-picker[open] { border-color:#ea4600; box-shadow:0 0 0 3px #ea460010; }
    .product-card__choice-picker summary { list-style:none; display:flex; align-items:center; justify-content:space-between; gap:12px; padding:14px 16px; min-height:66px; box-sizing:border-box; cursor:pointer; }
    .product-card__choice-picker summary::-webkit-details-marker { display:none; }
    .product-card__choice-picker summary strong { display:block; font-size:15px; line-height:1.35; color:#24201b; }
    .product-card__choice-picker summary small { display:block; margin-top:4px; font-size:12px; color:#796b5c; }
    .product-card__choice-picker summary svg { color:#d54308; flex-shrink:0; transition:transform .15s; }
    .product-card__choice-picker[open] summary svg { transform:rotate(180deg); }
    .product-card__choice-picker summary:focus-visible { outline:3px solid #ea4600; outline-offset:-4px; border-radius:10px; }
    .product-card__quick-dialog .product-card__choice-list { display:grid; gap:7px; max-height:250px; overflow-y:auto; overscroll-behavior:contain; margin:0; padding:10px; min-width:0; border:0; border-top:1px solid #eee1d3; background:#f8f2e9; scrollbar-width:thin; scrollbar-color:#c5aa8c #f8f2e9; }
    .product-card__choice-list legend { position:absolute; width:1px; height:1px; overflow:hidden; clip-path:inset(50%); }
    .product-card__quick-dialog label.product-card__choice { display:grid; grid-template-columns:18px minmax(0,1fr) auto; gap:11px; align-items:center; padding:12px; border:1px solid #e6dacc; border-radius:10px; background:#fffdf9; cursor:pointer; letter-spacing:0; }
    .product-card__quick-dialog label.product-card__choice:hover { background:#fff0e1; border-color:#e7aa80; }
    .product-card__quick-dialog label.product-card__choice:has(input:checked) { border-color:#ea4600; background:#fff0e1; box-shadow:inset 3px 0 #ea4600; }
    .product-card__choice input { appearance:auto; position:static; opacity:1; width:17px; height:17px; margin:0; accent-color:#ea4600; cursor:pointer; }
    .product-card__choice input:focus-visible { outline:2px solid #c33b00; outline-offset:3px; }
    .product-card__choice-values { display:flex; flex-wrap:wrap; gap:8px 18px; }
    .product-card__choice-values small { display:block; font-size:10px; line-height:1.3; letter-spacing:.04em; color:#796b5c; font-weight:650; }
    .product-card__choice-values strong { display:block; margin-top:3px; font-size:15px; line-height:1.3; color:#24201b; }
    .product-card__choice-price { text-align:right; }
    .product-card__choice-price strong { display:block; color:#9d360b; font-size:14px; }
    .product-card__choice-price small { display:block; margin-top:5px; font-size:10px; font-weight:600; color:#506346; }
    .product-card__choice-price small span { font-size:7px; vertical-align:middle; }
    @media(max-width:480px) { .product-card__quick-dialog .product-card__choice-list { max-height:210px; } .product-card__quick-dialog label.product-card__choice { padding:10px 8px; gap:8px; } }
    @media(prefers-reduced-motion:reduce) { .product-card__choice-picker summary svg { transition:none; } }

  `;
  document.head.append(quickAddStyle);
  const quickAddToBag = async (button, id, dialog) => {
    if (button.disabled || !id) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const card = button.closest('.product-card');
    let errorBox = card.querySelector('[data-card-quick-error]');
    if (errorBox) errorBox.hidden = true;
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
        body:JSON.stringify({items:[{id,quantity:1}]})
      });
      if (!response.ok) {
        const error = await response.json();
        const message = error.description || 'Could not add this item. Please try again.';
        const quantityLimit = response.status === 422 && /maximum|can['’]t add more|cannot add more|all .* in your cart/i.test(message);
        if (quantityLimit) {
          dialog?.close();
          await openDrawer();
          return;
        }
        throw new Error(message);
      }
      dialog?.close();
      await openDrawer();
    } catch (error) {
      if (!errorBox) {
        errorBox = document.createElement('p');
        errorBox.dataset.cardQuickError = '';
        errorBox.setAttribute('role','alert');
        card.querySelector('.product-card__body').append(errorBox);
      }
      errorBox.textContent = error.message;
      errorBox.hidden = false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };
  document.addEventListener('click', (event) => {
    const plus = event.target.closest('[data-card-quick-add]');
    if (plus) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const dialog = plus.closest('.product-card').querySelector('.product-card__quick-dialog');
      if (dialog) {
        dialog.querySelector('form').reset();
        const picker = dialog.querySelector('[data-card-choice-picker]');
        if (picker) {
          picker.open = false;
          picker.querySelector('[data-card-choice-title]').textContent = 'Choose your fit';
          const summary = picker.querySelector('[data-card-choice-summary]');
          summary.textContent = summary.dataset.defaultSummary;
        }
        dialog.querySelector('[data-card-quick-error]').hidden = true;
        dialog.showModal();
      } else quickAddToBag(plus, plus.dataset.variantId, null);
      return;
    }
    const dialog = event.target.closest('.product-card__quick-dialog');
    if (dialog) {
      event.stopPropagation();
      if (event.target.closest('[data-card-quick-close]')) dialog.close();
      if (event.target.closest('[type="submit"]') && !dialog.querySelector('[name="id"]:checked')) {
        const picker = dialog.querySelector('[data-card-choice-picker]');
        if (picker) picker.open = true;
      }
    }
  }, true);
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-card-quick-form]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const id = form.querySelector('[name="id"]:checked')?.value;
    if (!id || !form.reportValidity()) return;
    quickAddToBag(form.querySelector('[type="submit"]'), id, form.closest('dialog'));
  }, true);

  document.addEventListener('change', (event) => {
    const choice = event.target.closest('[data-card-choice]');
    if (!choice) return;
    const picker = choice.closest('[data-card-choice-picker]');
    picker.querySelector('[data-card-choice-title]').textContent = choice.dataset.choiceTitle;
    picker.querySelector('[data-card-choice-summary]').textContent = choice.dataset.choicePrice + ' · Ready to add';
    picker.open = false;
    picker.querySelector('summary').focus({ preventScroll: true });
  });
  document.addEventListener('invalid', (event) => {
    if (event.target.matches('[data-card-choice]')) event.target.closest('[data-card-choice-picker]').open = true;
  }, true);

  let drawerRemovalPending = false;
  drawerContent?.addEventListener('click', async (event) => {
    const link = event.target.closest('a[href*="/cart/change?"]');
    if (!link || event.defaultPrevented) return;
    event.preventDefault();
    if (drawerRemovalPending) return;
    const key = new URL(link.href).searchParams.get('id');
    if (!key) return;
    drawerRemovalPending = true;
    link.textContent = 'Removing…';
    link.setAttribute('aria-disabled', 'true');
    drawerContent.querySelector('[data-cart-remove-error]')?.remove();
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      if (!response.ok) throw new Error('Unable to remove item');
      await renderCart();
    } catch (error) {
      link.textContent = 'Remove';
      link.removeAttribute('aria-disabled');
      const message = document.createElement('p');
      message.dataset.cartRemoveError = '';
      message.setAttribute('role', 'alert');
      message.textContent = 'Could not update your bag. Please try again.';
      drawerContent.append(message);
    } finally {
      drawerRemovalPending = false;
    }
  });

  const openDrawer = async () => {
    if (!drawer) return;
    window.clearTimeout(drawerHideTimer);
    syncDrawerSheetMode();
    resetDrawerSheetDrag();
    drawer.classList.remove('is-expanded');
    drawer.hidden = false;
    document.documentElement.classList.add('cart-drawer-open');
    document.body.classList.add('cart-drawer-open');
    window.requestAnimationFrame(() => {
      drawer.classList.add('is-open');
    });
    await renderCart();
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open', 'is-expanded');
    resetDrawerSheetDrag();
    document.documentElement.classList.remove('cart-drawer-open');
    document.body.classList.remove('cart-drawer-open');
    window.clearTimeout(drawerHideTimer);
    drawerHideTimer = window.setTimeout(() => {
      if (!drawer.classList.contains('is-open')) {
        drawer.hidden = true;
        drawer.classList.remove('is-mobile-sheet');
      }
    }, 230);
  };

  const isMobileDrawer = () => (
    typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 990px)').matches
  );

  function syncDrawerSheetMode() {
    if (!drawer) return;
    drawer.classList.toggle('is-mobile-sheet', isMobileDrawer());
  }

  function resetDrawerSheetDrag() {
    if (!drawer) return;
    drawer.classList.remove('is-dragging');
    drawer.style.removeProperty('--cart-sheet-drag-y');
    drawer.style.removeProperty('--cart-sheet-overlay-opacity');
  }

  const setDrawerExpanded = (expanded) => {
    if (!drawer) return;
    syncDrawerSheetMode();
    drawer.classList.toggle('is-expanded', Boolean(expanded && isMobileDrawer()));
    resetDrawerSheetDrag();
  };

  let drawerSheetPointerId = null;
  let drawerSheetStartY = 0;
  let drawerSheetLastY = 0;
  let drawerSheetStartTime = 0;
  let drawerSheetWasExpanded = false;
  let drawerSheetMoved = false;

  const isInteractiveDrawerTarget = (target) => Boolean(target.closest(
    'a, button, input, textarea, select, summary, [role="button"]'
  ));

  const canStartDrawerSheetDrag = (event) => {
    if (!drawer || !drawerPanel || !isMobileDrawer() || !drawer.classList.contains('is-open')) return false;
    if (event.pointerType === 'mouse' && event.button !== 0) return false;
    if (isInteractiveDrawerTarget(event.target)) return false;

    const panelRect = drawerPanel.getBoundingClientRect();
    const isTopGrabZone = event.clientY - panelRect.top <= 76;
    const isHeader = Boolean(event.target.closest('.cart-drawer__header'));
    const content = event.target.closest('.cart-drawer__content');
    const canPullFromContentTop = content && content.scrollTop <= 2;

    return isHeader || isTopGrabZone || canPullFromContentTop;
  };

  const beginDrawerSheetDrag = (event) => {
    if (!canStartDrawerSheetDrag(event)) return;
    drawerSheetPointerId = event.pointerId;
    drawerSheetStartY = event.clientY;
    drawerSheetLastY = event.clientY;
    drawerSheetStartTime = Date.now();
    drawerSheetWasExpanded = drawer.classList.contains('is-expanded');
    drawerSheetMoved = false;
    drawer.classList.add('is-dragging');
    drawerPanel.setPointerCapture?.(event.pointerId);
    event.preventDefault();
  };

  const moveDrawerSheetDrag = (event) => {
    if (!drawer || event.pointerId !== drawerSheetPointerId) return;
    const deltaY = event.clientY - drawerSheetStartY;
    drawerSheetLastY = event.clientY;
    if (Math.abs(deltaY) > 8) drawerSheetMoved = true;

    const dragY = deltaY < 0 ? Math.max(deltaY * 0.22, -38) : deltaY;
    const overlayOpacity = Math.max(0.18, Math.min(1, 1 - Math.max(deltaY, 0) / 360));
    drawer.style.setProperty('--cart-sheet-drag-y', `${dragY}px`);
    drawer.style.setProperty('--cart-sheet-overlay-opacity', String(overlayOpacity));
    event.preventDefault();
  };

  const endDrawerSheetDrag = (event) => {
    if (!drawer || event.pointerId !== drawerSheetPointerId) return;
    const deltaY = drawerSheetLastY - drawerSheetStartY;
    const elapsed = Math.max(Date.now() - drawerSheetStartTime, 1);
    const velocityY = deltaY / elapsed;
    if (drawerPanel?.hasPointerCapture?.(drawerSheetPointerId)) {
      drawerPanel.releasePointerCapture(drawerSheetPointerId);
    }
    drawerSheetPointerId = null;

    if (deltaY < -44 || velocityY < -0.52) {
      setDrawerExpanded(true);
      return;
    }

    if (drawerSheetWasExpanded && deltaY > 58 && deltaY < 170 && velocityY < 0.92) {
      setDrawerExpanded(false);
      return;
    }

    if (deltaY > 96 || velocityY > 0.72) {
      closeDrawer();
      return;
    }

    setDrawerExpanded(drawerSheetWasExpanded);
  };

  drawerPanel?.addEventListener('pointerdown', beginDrawerSheetDrag);
  drawerPanel?.addEventListener('pointermove', moveDrawerSheetDrag);
  drawerPanel?.addEventListener('pointerup', endDrawerSheetDrag);
  drawerPanel?.addEventListener('pointercancel', endDrawerSheetDrag);
  drawerPanel?.addEventListener('lostpointercapture', endDrawerSheetDrag);
  window.addEventListener('pointerup', endDrawerSheetDrag, { passive: false });
  window.addEventListener('pointercancel', endDrawerSheetDrag, { passive: false });

  drawerPanel?.addEventListener('click', (event) => {
    if (!drawer || !isMobileDrawer() || !drawer.classList.contains('is-open')) return;
    if (drawerSheetMoved || isInteractiveDrawerTarget(event.target)) return;
    const panelRect = drawerPanel.getBoundingClientRect();
    const isTopGrabZone = event.clientY - panelRect.top <= 76;
    const isHeader = Boolean(event.target.closest('.cart-drawer__header'));
    if (isHeader || isTopGrabZone) setDrawerExpanded(!drawer.classList.contains('is-expanded'));
  });

  window.addEventListener('resize', () => {
    if (!drawer || drawer.hidden) return;
    syncDrawerSheetMode();
    if (!isMobileDrawer()) drawer.classList.remove('is-expanded');
    resetDrawerSheetDrag();
  }, { passive: true });

  const header = document.querySelector('[data-site-header]');
  let lastHeaderScrollY = Math.max(window.scrollY || 0, 0);
  let headerScrollDirection = lastHeaderScrollY > 92 ? 'down' : 'up';

  const syncHeader = () => {
    if (!header) return;

    const currentScrollY = Math.max(window.scrollY || 0, 0);
    const scrollDelta = currentScrollY - lastHeaderScrollY;
    if (Math.abs(scrollDelta) > 4) {
      headerScrollDirection = scrollDelta > 0 ? 'down' : 'up';
    }

    const isMobileHeader = typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 990px)').matches;
    const searchIsActive = Boolean(header.querySelector('.site-search')?.contains(document.activeElement));
    const condenseThreshold = isMobileHeader ? 18 : 92;
    const isPastTop = currentScrollY > 18;
    const shouldCondense = currentScrollY > condenseThreshold && headerScrollDirection === 'down' && !searchIsActive;
    header.classList.toggle('is-stuck', isPastTop);
    header.classList.toggle('is-condensed', shouldCondense);
    header.classList.toggle('is-expanded-on-scroll', isPastTop && !shouldCondense);
    header.dataset.scrollDirection = headerScrollDirection;
    lastHeaderScrollY = currentScrollY;
  };

  let scrollTicking = false;
  const requestHeaderSync = () => {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(() => {
      syncHeader();
      scrollTicking = false;
    });
  };

  window.addEventListener('scroll', requestHeaderSync, { passive: true });
  window.addEventListener('resize', requestHeaderSync, { passive: true });
  header.addEventListener('focusin', requestHeaderSync);
  header.addEventListener('focusout', requestHeaderSync);
  syncHeader();

  const placeConditionHelpButton = () => {
    const productInfo = document.querySelector('.product-info');
    if (!productInfo || productInfo.querySelector('.product-condition-value [data-help-drawer="condition"]')) return;

    const description = productInfo.querySelector('.product-description');
    if (!description || description.querySelector('[data-condition-inline-help]')) return;

    const conditionHeading = Array.from(description.querySelectorAll('h2, h3, h4, p')).find((node) => {
      const text = node.textContent.replace(/\s+/g, ' ').trim();
      return /^Condition\s*[-:\u2013\u2014]\s*\d(?:\s*\/\s*5)?/i.test(text);
    });
    if (!conditionHeading) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'product-condition-guide-button product-condition-guide-button--description';
    button.dataset.helpDrawer = 'condition';
    button.dataset.conditionInlineHelp = 'true';
    button.textContent = 'How we rate products';
    conditionHeading.classList.add('product-condition-heading');
    conditionHeading.append(button);
  };
  placeConditionHelpButton();

  const updateInfiniteProductCount = (grid) => {
    const countNode = document.querySelector('[data-infinite-product-count]');
    if (!grid || !countNode) return;
    const total = Number(countNode.dataset.infiniteTotal || 0);
    const loaded = grid.querySelectorAll('.product-card:not([hidden])').length;
    if (total > 0 && loaded > 0) {
      countNode.textContent = `Showing 1-${Math.min(loaded, total)} of ${total} products`;
    }
  };

  const setInfiniteStatus = (wrap, message) => {
    const status = wrap?.querySelector('[data-load-more-status]');
    if (status && message) status.textContent = message;
  };

  const finishInfiniteProducts = (wrap, grid) => {
    if (!wrap) return;
    const countNode = document.querySelector('[data-infinite-product-count]');
    const loaded = grid?.querySelectorAll('.product-card:not([hidden])').length || 0;
    const total = Number(countNode?.dataset.infiniteTotal || 0);
    if (countNode && loaded > 0) {
      countNode.textContent = total > loaded ? `Showing all ${loaded} available products` : `Showing all ${loaded} products`;
    }
    wrap.classList.remove('is-loading', 'has-load-error');
    wrap.classList.add('is-complete');
    wrap.innerHTML = '<div class="gear-request-mini"><p>That is everything loaded here. Still hunting?</p><a class="button button--primary" href="/pages/contact">Tell us what gear you want</a><a class="button button--ghost" href="/collections/all">Browse all gear</a></div>';
  };

  const requestInfiniteProductLoad = async (button, manual = false) => {
    if (!button || button.dataset.loading === 'true' || button.dataset.complete === 'true') return;
    const wrap = button.closest('[data-load-more-wrap]');
    const grid = document.querySelector('[data-product-grid]');
    const nextUrl = button.href;
    if (!wrap || !grid || !nextUrl) return;

    button.dataset.loading = 'true';
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Loading gear...';
    wrap.classList.add('is-loading');
    wrap.classList.remove('has-load-error');
    setInfiniteStatus(wrap, 'Loading more gear...');

    try {
      const response = await fetch(nextUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = doc.querySelector('[data-product-grid]');
      const nextButton = doc.querySelector('[data-load-more]');
      const existingKeys = new Set(Array.from(grid.querySelectorAll('.product-card')).map((card) => {
        const link = card.querySelector('a[href*="/products/"]');
        return link ? new URL(link.getAttribute('href'), window.location.origin).pathname : card.dataset.productTitle;
      }).filter(Boolean));
      let addedCount = 0;

      if (nextGrid) {
        nextGrid.querySelectorAll('.product-card').forEach((card) => {
          const link = card.querySelector('a[href*="/products/"]');
          const key = link ? new URL(link.getAttribute('href'), window.location.origin).pathname : card.dataset.productTitle;
          if (key && existingKeys.has(key)) return;
          if (key) existingKeys.add(key);
          grid.appendChild(card);
          addedCount += 1;
        });
      }

      updateInfiniteProductCount(grid);

      if (nextButton) {
        button.href = nextButton.href;
        button.dataset.loading = 'false';
        button.removeAttribute('aria-busy');
        button.textContent = 'Load more gear';
        wrap.classList.remove('is-loading');
        setInfiniteStatus(wrap, addedCount > 0 ? 'More gear will load as you scroll.' : 'Checking the next page...');

        if (addedCount === 0 || wrap.getBoundingClientRect().top < window.innerHeight + 900) {
          window.setTimeout(() => requestInfiniteProductLoad(button), 180);
        }
      } else {
        button.dataset.loading = 'false';
        button.dataset.complete = 'true';
        finishInfiniteProducts(wrap, grid);
      }
    } catch (error) {
      button.dataset.loading = 'false';
      button.removeAttribute('aria-busy');
      button.textContent = 'Load more gear';
      wrap.classList.remove('is-loading');
      wrap.classList.add('has-load-error');
      setInfiniteStatus(wrap, 'More gear did not auto-load. Tap the button to keep browsing.');
      if (manual) window.location.href = nextUrl;
    }
  };

  const initializeInfiniteProducts = () => {
    const wrappers = Array.from(document.querySelectorAll('[data-load-more-wrap]'));
    if (!wrappers.length) return;
    document.documentElement.classList.add('js-infinite-products');

    wrappers.forEach((wrap) => {
      if (wrap.dataset.infiniteReady === 'true') return;
      const button = wrap.querySelector('[data-load-more]');
      if (!button) return;
      wrap.dataset.infiniteReady = 'true';

      const maybeLoad = () => {
        if (button.dataset.complete === 'true') {
          window.removeEventListener('scroll', maybeLoad);
          window.removeEventListener('resize', maybeLoad);
          return;
        }
        if (wrap.getBoundingClientRect().top < window.innerHeight + 900) {
          requestInfiniteProductLoad(button);
        }
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) requestInfiniteProductLoad(button);
          });
        }, { rootMargin: '900px 0px 900px' });
        observer.observe(wrap);
      }
      window.addEventListener('scroll', maybeLoad, { passive: true });
      window.addEventListener('resize', maybeLoad, { passive: true });
      maybeLoad();
    });
  };

  document.addEventListener('pointerdown', (event) => {
    const pressable = event.target.closest('[data-inert-link], .button, .rail-controls button, .header-action');
    pressNode(pressable, true);
  });

  ['pointerup', 'pointercancel', 'pointerleave'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      const pressable = event.target.closest?.('[data-inert-link], .button, .rail-controls button, .header-action');
      pressNode(pressable, false);
    }, true);
  });

  const getHelpPanel = () => document.querySelector('[data-help-panel]');
  const isHelpPanelOpen = (panel = getHelpPanel()) => panel && !panel.hasAttribute('hidden');
  const closeHelpPanel = () => {
    const panel = getHelpPanel();
    if (!panel) return;
    panel.setAttribute('hidden', '');
    document.body.classList.remove('help-drawer-open');
  };
  const openHelpPanel = (button) => {
    const panel = getHelpPanel();
    if (panel && panel.parentElement !== document.body) document.body.appendChild(panel);
    const content = panel?.querySelector('[data-help-content]');
    const template = document.querySelector(`[data-help-template="${button.dataset.helpDrawer}"]`);
    if (!panel || !content || !template) return;
    content.innerHTML = template.innerHTML;
    panel.removeAttribute('hidden');
    document.body.classList.add('help-drawer-open');
    window.requestAnimationFrame(() => {
      panel.querySelector('.help-drawer__close')?.focus({ preventScroll: true });
    });
  };

  const clampProductMediaNumber = (value, min, max) => Math.min(max, Math.max(min, value));

  const fitProductGalleryImage = (img) => {
    if (!img || !img.closest('.product-page')) return;
    if (!img.complete || !img.naturalWidth || !img.naturalHeight) {
      img.addEventListener('load', () => fitProductGalleryImage(img), { once: true });
      return;
    }

    try {
      const canvas = document.createElement('canvas');
      const maxScanSize = 180;
      const scanScale = Math.min(1, maxScanSize / img.naturalWidth, maxScanSize / img.naturalHeight);
      const width = Math.max(1, Math.round(img.naturalWidth * scanScale));
      const height = Math.max(1, Math.round(img.naturalHeight * scanScale));
      canvas.width = width;
      canvas.height = height;

      const context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) return;
      context.drawImage(img, 0, 0, width, height);

      const imageData = context.getImageData(0, 0, width, height).data;
      const colorAt = (x, y) => {
        const index = ((y * width) + x) * 4;
        return [imageData[index], imageData[index + 1], imageData[index + 2]];
      };
      const cornerInsetX = Math.max(0, Math.min(width - 1, Math.round(width * 0.04)));
      const cornerInsetY = Math.max(0, Math.min(height - 1, Math.round(height * 0.04)));
      const corners = [
        colorAt(cornerInsetX, cornerInsetY),
        colorAt(width - 1 - cornerInsetX, cornerInsetY),
        colorAt(cornerInsetX, height - 1 - cornerInsetY),
        colorAt(width - 1 - cornerInsetX, height - 1 - cornerInsetY)
      ];
      const background = corners.reduce((sum, color) => [
        sum[0] + color[0],
        sum[1] + color[1],
        sum[2] + color[2]
      ], [0, 0, 0]).map((value) => value / corners.length);

      const colCounts = Array(width).fill(0);
      const rowCounts = Array(height).fill(0);

      for (let y = 0; y < height; y += 1) {
        for (let x = 0; x < width; x += 1) {
          const index = ((y * width) + x) * 4;
          const alpha = imageData[index + 3];
          if (alpha < 20) continue;

          const red = imageData[index];
          const green = imageData[index + 1];
          const blue = imageData[index + 2];
          const distance = Math.abs(red - background[0]) + Math.abs(green - background[1]) + Math.abs(blue - background[2]);
          const darkest = Math.min(red, green, blue);
          const lightest = Math.max(red, green, blue);
          const colorSpread = lightest - darkest;
          const nearWhiteBackground = red > 236 && green > 236 && blue > 236 && distance < 38;
          const foreground = !nearWhiteBackground && (distance > 32 || darkest < 232 || colorSpread > 18);

          if (foreground) {
            colCounts[x] += 1;
            rowCounts[y] += 1;
          }
        }
      }

      const colThreshold = Math.max(2, Math.round(height * 0.014));
      const rowThreshold = Math.max(2, Math.round(width * 0.014));
      const left = colCounts.findIndex((count) => count >= colThreshold);
      const right = colCounts.length - 1 - [...colCounts].reverse().findIndex((count) => count >= colThreshold);
      const top = rowCounts.findIndex((count) => count >= rowThreshold);
      const bottom = rowCounts.length - 1 - [...rowCounts].reverse().findIndex((count) => count >= rowThreshold);

      if (left < 0 || top < 0 || right <= left || bottom <= top) return;

      const boxWidth = right - left + 1;
      const boxHeight = bottom - top + 1;
      const centerX = (left + right + 1) / 2 / width;
      const centerY = (top + bottom + 1) / 2 / height;
      const fillX = boxWidth / width;
      const fillY = boxHeight / height;
      const productPage = img.closest('.product-page');
      const slide = img.closest('.product-gallery__slide');
      const mediaFit = productPage?.dataset.productMediaFit || '';
      img.removeAttribute('data-product-visual-fit');
      img.style.setProperty('--product-media-offset-x', '0px');
      img.style.setProperty('--product-media-offset-y', '0px');
      img.style.setProperty('--product-media-scale', '1');

      const slideRect = slide?.getBoundingClientRect();
      const imageRect = img.getBoundingClientRect();
      if (!slideRect || slideRect.width < 1 || slideRect.height < 1 || imageRect.width < 1 || imageRect.height < 1) return;

      const frameMargin = Math.max(5, Math.min(slideRect.width, slideRect.height) * 0.012);
      const maxScale = mediaFit === 'long-snow' ? 1.01 : mediaFit.includes('cam') ? 1.04 : 1.08;
      const desiredScale = Math.min(0.92 / Math.max(fillX, 0.01), 0.92 / Math.max(fillY, 0.01));
      const scaleRoomX = (slideRect.width - frameMargin * 2) / Math.max(imageRect.width, 1);
      const scaleRoomY = (slideRect.height - frameMargin * 2) / Math.max(imageRect.height, 1);
      const safeMaxScale = Math.max(1, Math.min(maxScale, scaleRoomX, scaleRoomY));
      const scale = clampProductMediaNumber(desiredScale, 1, safeMaxScale);
      const scaledImageWidth = imageRect.width * scale;
      const scaledImageHeight = imageRect.height * scale;
      const maxOffsetX = Math.max(0, (slideRect.width - scaledImageWidth) / 2 - frameMargin);
      const maxOffsetY = Math.max(0, (slideRect.height - scaledImageHeight) / 2 - frameMargin);
      const desiredOffsetX = (0.5 - centerX) * scaledImageWidth;
      const desiredOffsetY = (0.5 - centerY) * scaledImageHeight;
      const offsetX = clampProductMediaNumber(desiredOffsetX, -maxOffsetX, maxOffsetX);
      const offsetY = clampProductMediaNumber(desiredOffsetY, -maxOffsetY, maxOffsetY);

      img.style.setProperty('--product-media-offset-x', `${offsetX.toFixed(2)}px`);
      img.style.setProperty('--product-media-offset-y', `${offsetY.toFixed(2)}px`);
      img.style.setProperty('--product-media-scale', scale.toFixed(3));
      img.dataset.productVisualFit = 'true';
    } catch (error) {
      img.dataset.productVisualFit = 'fallback';
    }
  };

  const fitProductGalleryImages = (root = document) => {
    (root.querySelectorAll?.('.product-page .product-gallery__slide img') || []).forEach(fitProductGalleryImage);
  };

  const scheduleProductGalleryFit = (root = document) => {
    window.requestAnimationFrame(() => fitProductGalleryImages(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleProductGalleryFit(document), { once: true });
  } else {
    scheduleProductGalleryFit(document);
  }
  window.addEventListener('load', () => fitProductGalleryImages(document), { once: true });
  window.addEventListener('resize', () => scheduleProductGalleryFit(document), { passive: true });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.primary-nav')) {
      closePreparedDropdowns();
    }

    const inertLink = event.target.closest('[data-inert-link]');
    if (inertLink) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
        return;
      }
      event.preventDefault();
      const categoryPill = inertLink.closest('.category-pills') ? inertLink : null;
      if (categoryPill) {
        categoryPill.closest('.category-pills').querySelectorAll('.button.is-active').forEach((button) => {
          if (button !== categoryPill) button.classList.remove('is-active');
        });
        categoryPill.classList.add('is-active');
        preparedPulse(inertLink);
        return;
      }
      const destination = inertLink.dataset.preparedUrl || inertLink.getAttribute('href');
      preparedPulse(inertLink);
      if (destination && destination !== '#') {
        window.setTimeout(() => {
          window.location.href = destination;
        }, 140);
      }
      return;
    }

    const open = event.target.closest('[data-cart-drawer-open]');
    if (open) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-cart-drawer-close]')) {
      closeDrawer();
      return;
    }

    const prev = event.target.closest('[data-rail-prev]');
    const next = event.target.closest('[data-rail-next]');
    if (prev || next) {
      const rail = event.target.closest('.product-rail')?.querySelector('[data-product-rail]');
      if (!rail) return;
      const direction = next ? 1 : -1;
      rail.scrollBy({ left: direction * Math.max(rail.clientWidth * 0.82, 260), behavior: 'smooth' });
      window.setTimeout(() => updateRailControls(rail), 260);
      return;
    }

    const thumb = event.target.closest('[data-gallery-thumb]');
    if (thumb) {
      const gallery = thumb.closest('[data-product-gallery]');
      const index = thumb.dataset.galleryThumb;
      gallery.querySelectorAll('[data-gallery-slide], [data-gallery-thumb]').forEach((node) => {
        const value = node.dataset.gallerySlide || node.dataset.galleryThumb;
        node.classList.toggle('is-active', value === index);
      });
      scheduleProductGalleryFit(gallery);
      return;
    }

    const helpButton = event.target.closest('[data-help-drawer]');
    if (helpButton) {
      event.preventDefault();
      openHelpPanel(helpButton);
      return;
    }

    if (event.target.closest('[data-help-close]')) {
      event.preventDefault();
      closeHelpPanel();
      return;
    }

    const minus = event.target.closest('[data-quantity-minus]');
    const plus = event.target.closest('[data-quantity-plus]');
    if (minus || plus) {
      const stepper = event.target.closest('.quantity-stepper');
      const input = stepper?.querySelector('[data-quantity-input]');
      if (!input) return;
      const max = Number(input.max || 1);
      const min = Number(input.min || 1);
      const current = Number(input.value || 1);
      input.value = Math.max(min, Math.min(max, current + (plus ? 1 : -1)));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }

    const loadMore = event.target.closest('[data-load-more]');
    if (loadMore) {
      event.preventDefault();
      requestInfiniteProductLoad(loadMore, true);
    }
  });

  document.addEventListener('keydown', (event) => {
    const helpPanel = getHelpPanel();
    if (event.key === 'Escape' && isHelpPanelOpen(helpPanel)) {
      closeHelpPanel();
      return;
    }
    if (event.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
  });

  initializeInfiniteProducts();

  document.addEventListener('pointermove', (event) => {
    const slide = event.target.closest('[data-gallery-slide]');
    if (!slide) return;
    const img = slide.querySelector('img');
    if (!img) return;
    const rect = slide.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;
    img.style.transformOrigin = `${x}% ${y}%`;
  });

  document.addEventListener('pointerleave', (event) => {
    const slide = event.target.closest?.('[data-gallery-slide]');
    const img = slide?.querySelector('img');
    if (img) img.style.transformOrigin = 'center';
  }, true);

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const productPage = form.closest('.product-page');
    const variantScript = productPage?.querySelector('[data-product-variants]');
    const idInput = form.querySelector('[data-variant-id]');
    const submit = form.querySelector('[data-product-submit]');
    const buyNow = form.querySelector('[data-product-buy-now]');
    const purchaseButtons = [submit, buyNow].filter(Boolean);
    let purchasePending = false;
    let purchaseError;
    const priceBox = productPage?.querySelector('[data-price]');
    const qtyControl = form.querySelector('[data-quantity-control]');
    const qtyInput = form.querySelector('[data-quantity-input]');
    const hiddenQty = form.querySelector('[data-hidden-quantity]');
    const oneOfOne = form.querySelector('[data-one-of-one]');
    const stockNote = form.querySelector('[data-stock-note]');
    const isGiftCardForm = form.hasAttribute('data-gift-card-product-form');
    const giftRecipient = form.querySelector('[data-gift-recipient]');
    const giftRecipientToggle = form.querySelector('[data-gift-recipient-toggle]');
    const giftRecipientEnable = form.querySelector('[data-gift-recipient-enable]');
    const giftRecipientOffset = form.querySelector('[data-gift-recipient-offset]');
    const giftRecipientFields = form.querySelector('[data-gift-recipient-fields]');
    const giftRecipientInputs = Array.from(form.querySelectorAll('[data-gift-recipient-field]'));
    const giftRecipientEmail = form.querySelector('[data-gift-recipient-email]');
    let variants = [];

    try {
      variants = JSON.parse(variantScript?.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const optionGroups = Array.from(form.querySelectorAll('.product-options fieldset'));
    const optionSelectionState = new WeakMap();
    let selectionReminder;
    let reminderTimer;
    let reminderRemoveTimer;
    const hideSelectionReminder = () => {
      clearTimeout(reminderTimer);
      clearTimeout(reminderRemoveTimer);
      selectionReminder?.classList.remove('is-visible');
      reminderRemoveTimer = setTimeout(() => { selectionReminder?.remove(); selectionReminder = null; }, 180);
    };
    const showSelectionReminder = (anchor = submit) => {
      const missing = optionGroups.filter(group => !group.querySelector('input:checked'));
      if (!missing.length || !anchor) return;
      if (!document.getElementById('product-selection-reminder-style')) {
        const style = document.createElement('style');
        style.id = 'product-selection-reminder-style';
        style.textContent = '.product-submit-reminder-wrap{position:relative;width:100%}.product-submit-reminder-wrap>.product-form__submit{width:100%}.product-selection-reminder{position:absolute;z-index:3;bottom:100%;left:50%;box-sizing:border-box;width:max-content;max-width:100%;margin:0 0 8px;padding:10px 15px;border:1px solid #edc7a8;border-radius:12px;background:#fff7ed;color:#573923;box-shadow:0 4px 14px #44220c12;text-align:center;font-size:14px;line-height:1.4;font-weight:500;pointer-events:none;opacity:0;transform:translate(-50%,7px);transition:transform .18s ease}.product-selection-reminder.is-visible{opacity:1;transform:translate(-50%,0)}@media(prefers-reduced-motion:reduce){.product-selection-reminder{transition:none;transform:translate(-50%,0)}}';
        document.head.append(style);
      }
      let wrap = anchor.closest('.product-submit-reminder-wrap');
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'product-submit-reminder-wrap';
        anchor.before(wrap);
        wrap.append(anchor);
      }
      clearTimeout(reminderTimer);
      clearTimeout(reminderRemoveTimer);
      if (selectionReminder) wrap.append(selectionReminder);
      if (!selectionReminder) {
        selectionReminder = document.createElement('div');
        selectionReminder.className = 'product-selection-reminder';
        selectionReminder.setAttribute('role', 'status');
        selectionReminder.setAttribute('aria-live', 'polite');
        selectionReminder.setAttribute('aria-atomic', 'true');
        wrap.append(selectionReminder);
      }
      const names = missing.map(group => group.querySelector('legend')?.textContent.trim().replace(/\s*\([^)]*\)/g, '').toLowerCase()).filter(Boolean);
      const reminder = selectionReminder;
      setTimeout(() => {
        if (!reminder.isConnected) return;
        reminder.textContent = names.length ? 'Please select your ' + names.sort((a,b)=>(/size|length/.test(a)?0:1)-(/size|length/.test(b)?0:1)).join(' and ') + '.' : 'Please make a selection.';
        reminder.classList.add('is-visible');
      }, 20);
      reminderTimer = setTimeout(hideSelectionReminder, 2800);
    };
    form.addEventListener('change', hideSelectionReminder);
    // Explain missing options before the browser's form validation can stop submission.
    purchaseButtons.forEach(button => button.addEventListener('click', (event) => {
      if (!optionGroups.some(group => !group.querySelector('input:checked'))) return;
      event.preventDefault();
      showSelectionReminder(submit);
    }));

    const selectedOptions = () => optionGroups.map(fieldset => fieldset.querySelector('input:checked')?.value);
    const currentVariant = () => {
      if (!variants.length) return null;
      if (!optionGroups.length) return variants.find(candidate => String(candidate.id) === String(idInput?.value)) || variants[0];
      const selected = selectedOptions();
      return variants.find(candidate => candidate.options.every((option, index) => option === selected[index])) || null;
    };
    const updateOptionAvailability = () => {
      const selected = selectedOptions();
      optionGroups.forEach((fieldset, index) => {
        fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
          const available = variants.some(candidate => candidate.available && candidate.options[index] === input.value && candidate.options.every((value, otherIndex) => otherIndex === index || !selected[otherIndex] || value === selected[otherIndex]));
          input.disabled = false;
          optionSelectionState.set(input, input.checked);
          const label = input.closest('label');
          label?.classList.toggle('is-option-unavailable', !available);
          input.setAttribute('aria-label', input.value + (available ? '' : ' — unavailable with current selections; select to see other combinations'));
          if (label) { label.hidden = false; label.title = available ? '' : 'Select to see another combination'; }
        });
      });
    };
    let optionAdjustmentNote;
    const resolveOptionSelection = (event) => {
      const input = event?.target;
      if (!input?.matches?.('.product-options input[type="radio"]') || !input.checked) return;
      if (optionAdjustmentNote) optionAdjustmentNote.textContent = '';
      const index = optionGroups.indexOf(input.closest('fieldset'));
      const selected = selectedOptions();
      const matchesSelection = candidate => candidate.options.every((value, i) => !selected[i] || value === selected[i]);
      if (variants.some(candidate => candidate.available && matchesSelection(candidate))) return;
      const choices = variants.filter(candidate => candidate.options[index] === input.value);
      const availableChoices = choices.filter(candidate => candidate.available);
      const pool = availableChoices.length ? availableChoices : choices;
      const score = candidate => candidate.options.reduce((total, value, i) => total + (i !== index && selected[i] === value ? 1 : 0), 0);
      const replacement = pool.reduce((best, candidate) => !best || score(candidate) > score(best) ? candidate : best, null);
      if (!replacement) return;
      const changed = [];
      optionGroups.forEach((group, i) => {
        if (i === index || selected[i] === replacement.options[i]) return;
        group.querySelectorAll('input[type="radio"]').forEach(option => { option.checked = false; });
        changed.push(group.querySelector('legend')?.textContent.trim() || 'option');
      });
      if (changed.length) {
        if (!optionAdjustmentNote) {
          optionAdjustmentNote = document.createElement('p');
          optionAdjustmentNote.className = 'product-option-adjustment';
          optionAdjustmentNote.setAttribute('role', 'status');
          optionAdjustmentNote.setAttribute('aria-live', 'polite');
          form.querySelector('.product-options')?.after(optionAdjustmentNote);
        }
        optionAdjustmentNote.textContent = 'Please choose ' + changed.join(' and ') + ' to match your choice.';
      }
    };
    if (optionGroups.length) {
      if (!document.getElementById('product-option-availability-style')) {
        const style = document.createElement('style');
        style.id = 'product-option-availability-style';
        style.textContent = '.product-options .option-values label{display:inline-flex!important;visibility:visible!important;pointer-events:auto!important}.product-options .is-option-unavailable>span{background:#eeece8!important;color:#77716b!important;border-color:#c9c4bd!important;opacity:.72;position:relative;padding-right:28px!important}.product-options .is-option-unavailable>span::after{content:"×";position:absolute;right:9px;top:50%;transform:translateY(-50%);font-size:17px;line-height:1}.product-options .is-option-unavailable input:checked+span{outline:2px solid #b54108;outline-offset:2px}.product-options input:focus-visible+span{outline:2px solid #b54108;outline-offset:3px}.product-option-adjustment{font-size:13px;line-height:1.5;color:#655343;margin:8px 0 14px}.product-option-adjustment:empty{display:none}';
        document.head.append(style);
      }
      const linkedId = new URL(window.location.href).searchParams.get('variant');
      const linkedVariant = isGiftCardForm ? variants.find(candidate => candidate.available && String(candidate.id) === linkedId) : null;
      // Gear options require an explicit customer choice, including variant-linked arrivals.
      optionGroups.forEach((group, index) => group.querySelectorAll('input[type="radio"]').forEach(input => {
        input.checked = Boolean(linkedVariant && input.value === linkedVariant.options[index]);
      }));
    }

    const showQuantity = (variant) => {
      const tracked = Boolean(variant && variant.inventory_management);
      const qty = Number(variant?.inventory_quantity || 0);
      const multi = tracked && qty > 1;
      if (qtyControl) qtyControl.hidden = !multi;
      if (oneOfOne) oneOfOne.hidden = isGiftCardForm || multi || !variant?.available;
      if (qtyInput) {
        qtyInput.max = multi ? qty : 1;
        if (Number(qtyInput.value || 1) > qty) qtyInput.value = String(qty);
        if (Number(qtyInput.value || 1) < 1) qtyInput.value = '1';
      }
      if (hiddenQty) hiddenQty.value = multi ? (qtyInput?.value || '1') : '1';
      if (stockNote) {
        stockNote.textContent = multi ? `${qty} in stock` : '';
        stockNote.classList.toggle('stock-note--green', qty >= 4);
        stockNote.classList.toggle('stock-note--yellow', qty > 1 && qty < 4);
      }
    };

    const updatePrice = (variant) => {
      if (!priceBox || !variant) return;
      const price = Number(variant.price || 0);
      const compareAtPrice = Number(variant.compare_at_price || 0);
      priceBox.textContent = '';

      if (compareAtPrice > price) {
        const was = document.createElement('span');
        const sale = document.createElement('span');
        was.className = 'price__was';
        sale.className = 'price__sale';
        was.textContent = money(compareAtPrice);
        sale.textContent = money(price);
        priceBox.append(was, sale);
        return;
      }

      const regular = document.createElement('span');
      regular.className = 'price__regular';
      regular.textContent = money(price);
      priceBox.append(regular);
    };

    const updateVariant = () => {
      updateOptionAvailability();
      const variant = currentVariant();
      if (buyNow) {
        buyNow.disabled = purchasePending || (variant ? !variant.available : !variants.some(candidate => candidate.available));
        buyNow.textContent = (variant ? variant.available : variants.some(candidate => candidate.available)) ? 'Buy now' : 'Sold out';
      }
      if (!variant) {
        if (idInput) idInput.value = '';
        if (submit) {
          submit.disabled = purchasePending || !variants.some(candidate => candidate.available);
          submit.textContent = variants.some(candidate => candidate.available) ? (submit.dataset.submitLabel || 'Add to cart') : 'Sold out';
        }
        showQuantity(null);
        syncDropdowns();
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (submit) {
        submit.disabled = purchasePending || !variant.available;
        submit.textContent = variant.available ? (submit.dataset.submitLabel || 'Add to bag') : 'Sold out';
      }
      updatePrice(variant);
      showQuantity(variant);
      syncDropdowns();
    };


    // Branded dropdowns retain the original option order for variant IDs and galleries.
    const dropdowns = [];
    let dropdownStatus;
    const sizeFirst = form.getAttribute('id') === 'product_form_8041403252784';
    const dropdownOrder = optionGroups.map((group, index) => ({group,index,name:group.querySelector('legend')?.textContent.trim() || 'Option'})).sort((a,b) => {
      const rank = name => sizeFirst ? (/size|length/i.test(name) ? 0 : /colou?r/i.test(name) ? 1 : 2) : (/colou?r/i.test(name) ? 0 : /size|length/i.test(name) ? 1 : 2);
      return rank(a.name)-rank(b.name) || a.index-b.index;
    });
    const closeDropdowns = () => dropdowns.forEach(item => { item.list.hidden=true; item.trigger.setAttribute('aria-expanded','false'); });
    const syncDropdowns = () => {
      if (!dropdowns.length) return;
      const selected = selectedOptions();
      dropdowns.forEach((item, position) => {
        const earlier = dropdownOrder.slice(0,position);
        const unlocked = !sizeFirst || earlier.every(option => Boolean(selected[option.index]));
        item.trigger.disabled = !unlocked;
        item.value.textContent = selected[item.index] || (unlocked ? 'Choose '+item.name.toLowerCase() : 'Choose '+earlier.find(option => !selected[option.index])?.name.toLowerCase()+' first');
        item.trigger.classList.toggle('has-selection', Boolean(selected[item.index]));
        item.options.forEach(({button,input}) => {
          const available = variants.some(candidate => candidate.available && candidate.options[item.index]===input.value && earlier.every(option => !selected[option.index] || candidate.options[option.index]===selected[option.index]));
          button.disabled=!available;
          button.setAttribute('aria-selected', String(selected[item.index]===input.value));
          button.querySelector('small').textContent=available ? '' : 'Unavailable';
        });
      });
      const ready = Boolean(currentVariant()?.available);
      const missingSelection = optionGroups.some(group => !group.querySelector('input:checked'));
      purchaseButtons.forEach(button => {button.disabled=purchasePending || (!ready && !missingSelection);});
      const wallet=form.querySelector('.product-express-actions__wallet');
      if(wallet) {wallet.hidden=false; wallet.inert=!ready; wallet.setAttribute('aria-disabled',String(!ready)); wallet.style.opacity=ready?'1':'.55';}
      form.querySelector('.product-express-actions')?.classList.remove('is-awaiting-options');
      dropdownStatus.textContent=ready ? 'Your selection is in stock.' : 'Choose your '+dropdownOrder.filter(item=>!selected[item.index]).map(item=>item.name.toLowerCase()).join(' and ')+' to continue.';
    };
    if(optionGroups.length) {
      if(!document.getElementById('gearonimo-variant-dropdown-style')) {
        const style=document.createElement('style');style.id='gearonimo-variant-dropdown-style';
        style.textContent='.gx-variant-picker{display:grid;gap:14px;margin:18px 0}.gx-variant-field{position:relative;min-width:0}.gx-variant-label{display:block;font-size:12px;font-weight:800;letter-spacing:.09em;text-transform:uppercase;color:#493b2e;margin-bottom:7px}.gx-variant-trigger{display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;min-height:54px;padding:14px 16px;border:1px solid #cfc3b3;border-radius:12px;background:#fffaf2;color:#25221f;font:inherit;font-size:15px;font-weight:650;text-align:left;cursor:pointer;box-shadow:0 2px 5px #38241108}.gx-variant-trigger::after{content:"";width:8px;height:8px;border-right:2px solid #d64b00;border-bottom:2px solid #d64b00;transform:rotate(45deg);margin:0 3px 4px 8px;flex:none}.gx-variant-trigger[aria-expanded=true],.gx-variant-trigger:focus-visible{outline:2px solid #f45a00;outline-offset:2px}.gx-variant-trigger.has-selection{border-color:#bd7a45;background:#fff7e9}.gx-variant-trigger:disabled{background:#f0ede7;color:#857a6f;cursor:not-allowed}.gx-variant-list{position:absolute;z-index:30;top:100%;left:0;right:0;margin:7px 0 0;padding:6px;border:1px solid #d6c7b5;border-radius:12px;background:#fffdf8;box-shadow:0 12px 30px #35231526;max-height:270px;overflow:auto;overscroll-behavior:contain}.gx-variant-list[hidden]{display:none!important}.gx-variant-choice{display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;min-height:44px;border:0;border-radius:7px;padding:11px 12px;background:transparent;color:#29231d;text-align:left;font:inherit;font-size:14px;cursor:pointer}.gx-variant-choice:hover:not(:disabled),.gx-variant-choice:focus-visible{background:#fbe8d6;outline:2px solid #f45a00;outline-offset:-2px}.gx-variant-choice[aria-selected=true]{background:#f9dfc6;font-weight:800}.gx-variant-choice:disabled{color:#827b73;cursor:not-allowed}.gx-variant-choice:disabled>span{text-decoration:line-through;text-decoration-thickness:1.5px}.gx-variant-choice small{font-size:11px;font-weight:500;text-decoration:none}.gx-variant-status{margin:0;font-size:12px;line-height:1.5;color:#6a5847}.product-express-actions__wallet[hidden]{display:none!important}.product-express-actions.is-awaiting-options{grid-template-columns:1fr}.product-options[data-dropdown-source]{display:none!important}';
        document.head.append(style);
      }
      const container=document.createElement('div');container.className='gx-variant-picker';
      const source=form.querySelector('.product-options');source.before(container);source.setAttribute('data-dropdown-source','');
      dropdownOrder.forEach(({group,index,name},position)=> {
        const field=document.createElement('div');field.className='gx-variant-field';
        const label=document.createElement('span');label.className='gx-variant-label';label.id=form.getAttribute('id')+'-option-label-'+index;label.textContent=name;
        const trigger=document.createElement('button');trigger.type='button';trigger.className='gx-variant-trigger';trigger.setAttribute('role','combobox');trigger.setAttribute('aria-haspopup','listbox');trigger.setAttribute('aria-expanded','false');trigger.setAttribute('aria-labelledby',label.id);trigger.setAttribute('aria-required','true');
        const value=document.createElement('span');trigger.append(value);
        const list=document.createElement('div');list.className='gx-variant-list';list.id=form.getAttribute('id')+'-option-list-'+index;list.setAttribute('role','listbox');list.setAttribute('aria-labelledby',label.id);list.hidden=true;trigger.setAttribute('aria-controls',list.id);
        const item={index,name,trigger,value,list,options:[]};dropdowns.push(item);
        const choices = [...group.querySelectorAll('input[type=radio]')];
        if (sizeFirst && /size|length/i.test(name)) choices.sort((a,b) => a.value.localeCompare(b.value, undefined, {numeric:true,sensitivity:'base'}));
        choices.forEach(input=> {
          const button=document.createElement('button');button.type='button';button.className='gx-variant-choice';button.setAttribute('role','option');button.setAttribute('aria-selected','false');button.tabIndex=-1;
          const text=document.createElement('span');text.textContent=input.value;const note=document.createElement('small');button.append(text,note);list.append(button);item.options.push({button,input});
          button.addEventListener('click',()=> {
            if(button.disabled)return;
            const kept = new Map([[index,input.value]]);
            dropdownOrder.filter(next=>next.index!==index).forEach(next=>{
              const checked=next.group.querySelector('input:checked');
              if(!checked)return;
              const compatible=variants.some(candidate=>candidate.available && candidate.options[next.index]===checked.value && [...kept].every(([i,value])=>candidate.options[i]===value));
              if(compatible)kept.set(next.index,checked.value);
              else checked.checked=false;
            });
            input.checked=true;closeDropdowns();input.dispatchEvent(new Event('change',{bubbles:true}));trigger.focus();
          });
        });
        const open=()=> {const wasOpen=!list.hidden;closeDropdowns();if(wasOpen)return;list.hidden=false;trigger.setAttribute('aria-expanded','true');(item.options.find(option=>option.input.checked&&!option.button.disabled)||item.options.find(option=>!option.button.disabled))?.button.focus();};
        trigger.addEventListener('click',open);
        trigger.addEventListener('keydown',event=>{if(['ArrowDown','ArrowUp'].includes(event.key)){event.preventDefault();if(list.hidden)open();}});
        list.addEventListener('keydown',event=> {
          const enabled=item.options.map(option=>option.button).filter(button=>!button.disabled);const at=enabled.indexOf(document.activeElement);
          if(event.key==='Escape'){event.preventDefault();closeDropdowns();trigger.focus();}
          else if(['ArrowDown','ArrowUp','Home','End'].includes(event.key)){event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?enabled.length-1:(at+(event.key==='ArrowDown'?1:-1)+enabled.length)%enabled.length;enabled[next]?.focus();}
          else if(event.key==='Tab')closeDropdowns();
          else if(event.key.length===1&&!event.ctrlKey&&!event.metaKey){const match=enabled.find(button=>button.textContent.toLowerCase().startsWith(event.key.toLowerCase()));match?.focus();}
        });
        field.append(label,trigger,list);container.append(field);
      });
      [...dropdowns].sort((a,b)=>{const rank=name=>/size|length/i.test(name)?0:/colou?r/i.test(name)?1:2;return rank(a.name)-rank(b.name);}).forEach(item=>container.append(item.trigger.closest('.gx-variant-field')));
      dropdownStatus=document.createElement('p');dropdownStatus.className='gx-variant-status';dropdownStatus.setAttribute('role','status');dropdownStatus.setAttribute('aria-live','polite');container.append(dropdownStatus);
      document.addEventListener('click',event=>{if(!container.contains(event.target))closeDropdowns();});
      form.addEventListener('change',()=>queueMicrotask(syncDropdowns));
      window.addEventListener('pageshow',()=>queueMicrotask(syncDropdowns));
    }

    form.addEventListener('click', event => {
      const input = event.target;
      if (!input.matches?.('.product-options input[type="radio"]') || input.disabled) return;
      if (optionSelectionState.get(input)) {
        input.checked = false;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    form.addEventListener('change', event => { resolveOptionSelection(event); updateVariant(); });

    const syncGiftRecipient = () => {
      if (!giftRecipient) return;
      const enabled = Boolean(giftRecipientToggle?.checked);
      giftRecipient.classList.toggle('is-active', enabled);
      if (giftRecipientFields) giftRecipientFields.hidden = !enabled;
      if (giftRecipientEnable) giftRecipientEnable.disabled = !enabled;
      if (giftRecipientOffset) {
        giftRecipientOffset.disabled = !enabled;
        giftRecipientOffset.value = String(new Date().getTimezoneOffset());
      }
      giftRecipientInputs.forEach((input) => {
        input.disabled = !enabled;
      });
      if (giftRecipientEmail) giftRecipientEmail.required = enabled;
      const sendOn = form.querySelector('input[name="properties[Send on]"]');
      if (sendOn && !sendOn.max) {
        const maxDate = new Date();
        maxDate.setDate(maxDate.getDate() + 90);
        sendOn.max = maxDate.toISOString().slice(0, 10);
      }
    };

    giftRecipientToggle?.addEventListener('change', syncGiftRecipient);
    syncGiftRecipient();

    qtyInput?.addEventListener('input', () => {
      const max = Number(qtyInput.max || 1);
      const min = Number(qtyInput.min || 1);
      qtyInput.value = Math.max(min, Math.min(max, Number(qtyInput.value || 1)));
      if (hiddenQty) hiddenQty.value = qtyInput.value;
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (purchasePending) return;
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;
      const selectedVariant = currentVariant();
      if (!selectedVariant || !selectedVariant.available) { updateVariant(); showSelectionReminder(); return; }
      const goToCheckout = event.submitter === buyNow;
      if (idInput) idInput.value = selectedVariant.id;
      const formData = new FormData(form);
      purchasePending = true;
      if (purchaseError) purchaseError.textContent = '';
      purchaseButtons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(typeof error.description === 'string' ? error.description : 'This item could not be added. Please check your selection and try again.');
        }
        if (goToCheckout) {
          window.location.assign('/checkout');
          return;
        }
        submit?.classList.add('is-added');
        setTimeout(() => submit?.classList.remove('is-added'), 650);
        await openDrawer();
      } catch (error) {
        if (!purchaseError) {
          purchaseError = document.createElement('p');
          purchaseError.className = 'product-purchase-error';
          purchaseError.setAttribute('role', 'alert');
          (buyNow || submit).after(purchaseError);
        }
        purchaseError.textContent = error.message || 'Please check your connection and try again.';
      } finally {
        purchasePending = false;
        purchaseButtons.forEach(button => button.removeAttribute('aria-busy'));
        updateVariant();
      }
    });

    updateVariant();
  });

  // Keep older homepage/footer category links on the same size-first collections as the menu.
  document.querySelectorAll('a[href]').forEach((link) => {
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin) return;
    const family = url.searchParams.get('filter.p.m.catalog.product_family');
    const snowTargets = { Skis: 'backcountry-skiing-skis', Snowboards: 'snowboards-gear' };
    if (url.pathname === '/collections/snow' && snowTargets[family]) {
      url.pathname = '/collections/' + snowTargets[family];
      url.searchParams.delete('filter.p.m.catalog.product_family');
      url.searchParams.set('filter.v.availability', '1');
      link.href = url.pathname + url.search + url.hash;
    } else if (url.pathname === '/collections/camp-hike') {
      url.pathname = '/collections/camp-and-hike';
      url.searchParams.set('filter.v.availability', '1');
      link.href = url.pathname + url.search + url.hash;
    }
  });

  document.querySelectorAll('.keep-browsing__viewport--marquee').forEach((rail) => {
    const handle = rail.closest('.keep-browsing')?.querySelector('.keep-browsing__center-handle');
    const arrowControls = rail.closest('.keep-browsing')?.querySelector('.keep-browsing__arrow-controls');
    const saleRail = Boolean(rail.closest('.keep-browsing--hero'));
    const mobileLayout = window.matchMedia('(max-width: 720px), (hover: none) and (pointer: coarse)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visibleElapsed = 0;
    let initialHoldDone = false;
    let touching = false;
    const orderCategories = () => {
      if (!saleRail) return;
      const order = ['snowboards-gear', 'backcountry-skiing-skis', 'hiking-poles', 'camp-and-hike', 'climbing', 'in-store'];
      rail.querySelectorAll('.keep-browsing__marquee-set').forEach((set) => {
        const cards = Array.from(set.children);
        const rank = (card) => {
          const url = new URL(card.href, location.origin);
          const key = url.searchParams.get('filter.p.m.catalog.product_family') || url.pathname.split('/').filter(Boolean).pop();
          const index = order.indexOf(key);
          return index < 0 ? order.length : index;
        };
        cards.sort((a, b) => rank(a) - rank(b)).forEach((card) => {
          // Keep older mobile CSS ordering in sync with the accessible DOM order.
          card.style.setProperty('order', '0', 'important');
          set.append(card);
        });
      });
      visibleElapsed = 0;
      initialHoldDone = false;
    };
    orderCategories();
    let pointerId = null;
    let pointerSource = null;
    let startX = 0;
    let startScrollLeft = 0;
    let didDrag = false;
    let suppressClick = false;
    let pauseTimer;
    let autoScrollingTimer;
    let autoFrame;
    let lastAutoTime;
    let autoScrollPosition = 0;
    const hoverPauseQuery = typeof window.matchMedia === 'function'
      ? window.matchMedia('(hover: hover) and (pointer: fine)')
      : { matches: true };

    const maxScroll = () => Math.max(rail.scrollWidth - rail.clientWidth, 0);
    let handleProgressTicking = false;

    const setHandleProgress = () => {
      if (!handle) return;
      const trackWidth = Math.max(handle.clientWidth, 1);
      const max = maxScroll();
      const visibleRatio = rail.scrollWidth > 0 ? rail.clientWidth / rail.scrollWidth : 1;
      const thumbRatio = Math.min(Math.max(visibleRatio, 0.32), 1);
      const thumbWidth = Math.min(trackWidth, Math.max(28, trackWidth * thumbRatio));
      const progress = max > 0 ? Math.min(Math.max(rail.scrollLeft / max, 0), 1) : 0;
      const thumbLeft = (trackWidth - thumbWidth) * progress;

      handle.style.setProperty('--category-scroll-thumb-width', `${thumbWidth.toFixed(2)}px`);
      handle.style.setProperty('--category-scroll-thumb-left', `${thumbLeft.toFixed(2)}px`);
    };

    const requestHandleProgress = () => {
      if (handleProgressTicking) return;
      handleProgressTicking = true;
      window.requestAnimationFrame(() => {
        setHandleProgress();
        handleProgressTicking = false;
      });
    };

    rail.addEventListener('scroll', requestHandleProgress, { passive: true });
    window.requestAnimationFrame(setHandleProgress);
    window.addEventListener('load', requestHandleProgress, { once: true });
    window.addEventListener('resize', requestHandleProgress, { passive: true });
    [120, 420, 1000, 1800].forEach((delay) => window.setTimeout(requestHandleProgress, delay));

    if ('ResizeObserver' in window) {
      const handleProgressObserver = new ResizeObserver(requestHandleProgress);
      handleProgressObserver.observe(rail);
      const track = rail.querySelector('.keep-browsing__track');
      if (track) handleProgressObserver.observe(track);
    }

    if (mobileLayout.matches) {
      rail.dataset.mobileMarquee = 'true';
      handle?.setAttribute('aria-hidden', 'true');
      handle?.setAttribute('tabindex', '-1');
    }

    const marqueeSetCount = () => Math.max(rail.querySelectorAll('.keep-browsing__marquee-set').length, 1);
    const cycleWidth = () => {
      const sets = rail.querySelectorAll('.keep-browsing__marquee-set');
      return sets.length > 1 ? sets[1].firstElementChild.getBoundingClientRect().left - sets[0].firstElementChild.getBoundingClientRect().left : rail.scrollWidth;
    };
    const centerScroll = () => saleRail ? cycleWidth() : (mobileLayout.matches ? 0 : maxScroll() / 2);
    const shouldPauseForHover = () => hoverPauseQuery.matches && rail.matches(':hover');
    const shouldPauseForFocus = () => rail.matches(':focus-within');
    const autoScrollSpeed = hoverPauseQuery.matches ? 0.024 : 0.026;

    const railIsVisible = () => {
      const rect = rail.getBoundingClientRect();
      const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
      return visibleHeight >= Math.min(rect.height, window.innerHeight) * 0.25;
    };
    rail.addEventListener('pointerdown', () => { touching = true; visibleElapsed = 0; }, { passive: true });
    const finishTouch = () => { touching = false; visibleElapsed = 0; };
    window.addEventListener('pointerup', finishTouch, { passive: true });
    window.addEventListener('pointercancel', finishTouch, { passive: true });
    rail.addEventListener('wheel', () => { visibleElapsed = 0; }, { passive: true });
    mobileLayout.addEventListener('change', () => {
      orderCategories();
      rail.dataset.mobileMarquee = String(mobileLayout.matches);
      handle?.setAttribute('aria-hidden', String(mobileLayout.matches));
      handle?.setAttribute('tabindex', mobileLayout.matches ? '-1' : '0');
      window.requestAnimationFrame(centerMarquee);
    });

    const setProgrammaticScroll = (value) => {
      window.clearTimeout(autoScrollingTimer);
      rail.dataset.autoScrolling = 'true';
      rail.scrollLeft = value;
      autoScrollPosition = rail.scrollLeft;
      autoScrollingTimer = window.setTimeout(() => {
        delete rail.dataset.autoScrolling;
      }, 140);
    };

    const centerMarquee = () => {
      if (maxScroll() <= 0) return;
      setProgrammaticScroll(centerScroll());
    };

    const normalizeMarquee = () => {
      if (mobileLayout.matches && !saleRail) {
        autoScrollPosition = rail.scrollLeft;
        return;
      }
      const width = cycleWidth();
      const max = maxScroll();
      if (width <= 0 || max <= 0) return;

      const center = centerScroll();
      const current = rail.scrollLeft;
      let best = current;
      let bestDistance = Math.abs(current - center);

      [-2, -1, 1, 2].forEach((offset) => {
        const candidate = current + (offset * width);
        if (candidate < 0 || candidate > max) return;
        const distance = Math.abs(candidate - center);
        if (distance < bestDistance) {
          best = candidate;
          bestDistance = distance;
        }
      });

      if (Math.abs(best - current) > 1) {
        setProgrammaticScroll(best);
      } else {
        autoScrollPosition = rail.scrollLeft;
      }
    };

    const pauseMarquee = (resumeDelay = 1400) => {
      if (rail.dataset.autoScrolling === 'true') return;
      const delay = Number.isFinite(resumeDelay) ? resumeDelay : 1400;
      autoScrollPosition = rail.scrollLeft;
      rail.classList.add('is-user-scrolling');
      window.clearTimeout(pauseTimer);
      pauseTimer = window.setTimeout(() => {
        normalizeMarquee();
        rail.classList.remove('is-user-scrolling');
      }, delay);
    };

    arrowControls?.addEventListener('click', (event) => {
      const button = event.target.closest('[data-rail-prev], [data-rail-next]');
      if (!button || button.disabled) return;

      // Let the arrow's smooth scroll finish before the marquee resumes.
      window.clearTimeout(autoScrollingTimer);
      delete rail.dataset.autoScrolling;
      initialHoldDone = true;
      visibleElapsed = 0;
      pauseMarquee(1400);
    });

    rail.addEventListener('scroll', () => {
      if (saleRail && (rail.scrollLeft < cycleWidth() * .25 || rail.scrollLeft > maxScroll() - cycleWidth() * .25)) normalizeMarquee();
      pauseMarquee(hoverPauseQuery.matches ? 1400 : 650);
    }, { passive: true });

    const beginDrag = (event, source) => {
      if (event.button !== 0) return;
      if (pointerId !== null) return;
      pauseMarquee(event.pointerType === 'touch' ? 650 : 1400);
      if (source === rail && event.pointerType === 'touch') return;
      pointerId = event.pointerId;
      pointerSource = source;
      startX = event.clientX;
      startScrollLeft = rail.scrollLeft;
      didDrag = false;
      rail.classList.add('is-user-scrolling');
      if (source !== rail) {
        source.setPointerCapture?.(event.pointerId);
        if (event.cancelable) event.preventDefault();
      }
    };

    const moveDrag = (event) => {
      if (event.pointerId !== pointerId) return;
      const deltaX = event.clientX - startX;
      if (Math.abs(deltaX) <= 12) return;
      didDrag = true;
      rail.classList.add('is-dragging');
      handle?.classList.add('is-dragging');
      const captureNode = pointerSource || rail;
      if (!captureNode.hasPointerCapture?.(event.pointerId)) captureNode.setPointerCapture?.(event.pointerId);
      rail.scrollLeft = startScrollLeft - deltaX;
      normalizeMarquee();
      startScrollLeft = rail.scrollLeft + deltaX;
      pauseMarquee();
      if (pointerSource !== rail && event.cancelable) event.preventDefault();
    };

    const endDrag = (event) => {
      if (event.pointerId !== pointerId) return;
      const captureNode = pointerSource || rail;
      if (captureNode.hasPointerCapture?.(pointerId)) captureNode.releasePointerCapture(pointerId);
      if (didDrag) {
        if (rail.contains(document.activeElement)) document.activeElement.blur();
        suppressClick = true;
        window.setTimeout(() => {
          suppressClick = false;
        }, 350);
      }
      pointerId = null;
      pointerSource = null;
      didDrag = false;
      rail.classList.remove('is-dragging');
      handle?.classList.remove('is-dragging');
      normalizeMarquee();
      pauseMarquee();
    };

    rail.addEventListener('pointerdown', (event) => beginDrag(event, rail));
    rail.addEventListener('pointermove', moveDrag);
    rail.addEventListener('pointerup', endDrag);
    rail.addEventListener('pointercancel', endDrag);

    if (handle) {
      handle.addEventListener('pointerdown', (event) => beginDrag(event, handle));
      handle.addEventListener('pointermove', moveDrag);
      handle.addEventListener('pointerup', endDrag);
      handle.addEventListener('pointercancel', endDrag);
      handle.addEventListener('click', (event) => {
        event.preventDefault();
      });
    }

    rail.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);

    rail.addEventListener('click', (event) => {
      if (suppressClick || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const card = event.target.closest('.browse-category-card[href]');
      if (!card || !rail.contains(card)) return;
      event.preventDefault();
      window.location.href = card.href;
    });

    const autoScroll = (time) => {
      const lastTime = lastAutoTime || time;
      lastAutoTime = time;
            const shouldMove = !saleRail && maxScroll() > 0 && !document.hidden && !reducedMotion.matches && railIsVisible() && !touching && !shouldPauseForHover() && !shouldPauseForFocus() && !rail.classList.contains('is-user-scrolling') && !rail.classList.contains('is-dragging');
      if (shouldMove) {
        visibleElapsed += Math.min(time - lastTime, 50);
        if (saleRail && mobileLayout.matches) {
          if (visibleElapsed >= 3000) {
            const cards = Array.from(rail.querySelector('.keep-browsing__marquee-set').children);
            const firstLeft = cards[0].getBoundingClientRect().left;
            const positions = cards.map((card) => card.getBoundingClientRect().left - firstLeft);
            const next = positions.find((left) => left > rail.scrollLeft + 10);
            const target = rail.scrollLeft >= maxScroll() - 2 ? 0 : Math.min(next ?? maxScroll(), maxScroll());
            visibleElapsed = 0;
            window.clearTimeout(autoScrollingTimer);
            rail.dataset.autoScrolling = 'true';
            autoScrollingTimer = window.setTimeout(() => { delete rail.dataset.autoScrolling; }, 800);
            rail.scrollTo({ left: target, behavior: 'smooth' });
          }
        } else if (!saleRail || initialHoldDone || visibleElapsed >= 3000) {
          initialHoldDone = true;
          if (Math.abs(autoScrollPosition - rail.scrollLeft) > 2) autoScrollPosition = rail.scrollLeft;
          const cards = rail.querySelector('.keep-browsing__marquee-set').children;
          const cardStep = cards.length > 1 ? cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left : 240;
          const distance = Math.min(time - lastTime, 50) * (saleRail ? cardStep / 10000 : autoScrollSpeed);
          autoScrollPosition += distance;
          setProgrammaticScroll(autoScrollPosition);
          normalizeMarquee();
        }
      }
      autoFrame = window.requestAnimationFrame(autoScroll);
    };

    window.requestAnimationFrame(centerMarquee);
    window.addEventListener('load', centerMarquee, { once: true });
    window.setTimeout(centerMarquee, 350);
    window.setTimeout(centerMarquee, 1100);
  if ('ResizeObserver' in window) {
    const marqueeResizeObserver = new ResizeObserver(() => {
      if (rail.classList.contains('is-dragging')) return;
      centerMarquee();
    });
      marqueeResizeObserver.observe(rail);
    } else {
      window.addEventListener('resize', centerMarquee, { passive: true });
    }

    autoFrame = window.requestAnimationFrame(autoScroll);
  });

  const syncFooterAccordions = () => {
    const footerAccordions = Array.from(document.querySelectorAll('.site-footer [data-footer-accordion]'));
    if (!footerAccordions.length) return;

    footerAccordions.forEach((accordion) => {
      if (accordion.tagName !== 'DETAILS') return;

      accordion.open = true;
      delete accordion.dataset.footerMobileReady;
    });
  };

  syncFooterAccordions();
  window.addEventListener('resize', () => {
    window.requestAnimationFrame(syncFooterAccordions);
  }, { passive: true });

  const initEmployeeFavoritesRail = () => {
    const rail = document.querySelector('[data-employee-favorites-rail]');
    if (!rail) return;

    const limit = Number(rail.dataset.employeeFavoritesLimit || 16);
    const cards = Array.from(rail.querySelectorAll('[data-employee-favorite-card]'));
    const viewport = rail.closest('[data-product-rail]');
    const syncEmployeeRail = () => {
      document.dispatchEvent(new CustomEvent('gearonimo:rail:update', {
        detail: { rail: viewport },
      }));
    };

    const applyAvailability = (availability) => {
      let visibleCount = 0;

      cards.forEach((card, index) => {
        const showCard = availability[index] && visibleCount < limit;
        card.hidden = !showCard;
        if (showCard) visibleCount += 1;
      });
      syncEmployeeRail();
    };

    const initialAvailability = cards.map(
      (card) => card.dataset.productFallback === 'true'
        ? false
        : card.dataset.productAvailable !== 'false',
    );
    applyAvailability(initialAvailability);

    Promise.all(
      cards.map(async (card, index) => {
        if (card.dataset.productAvailable === 'false') return false;
        if (card.dataset.productFallback !== 'true') return initialAvailability[index];

        const handle = card.dataset.productHandle;
        if (!handle) return false;

        try {
          const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) return false;

          const product = await response.json();
          return product.available !== false;
        } catch {
          return false;
        }
      }),
    ).then(applyAvailability);

    window.addEventListener('load', syncEmployeeRail, { once: true });
    window.addEventListener('resize', syncEmployeeRail, { passive: true });
    [120, 420, 1000, 1800].forEach((delay) => window.setTimeout(syncEmployeeRail, delay));
  };

  initEmployeeFavoritesRail();

  document.querySelectorAll('.product-rail--reverse [data-product-rail]').forEach((rail) => {
    rail.scrollLeft = rail.scrollWidth;
  });

  const updateRailControls = (rail) => {
    const section = rail.closest('.product-rail');
    if (!section) return;
    const prev = section.querySelector('[data-rail-prev]');
    const next = section.querySelector('[data-rail-next]');
    const maxScroll = Math.max(rail.scrollWidth - rail.clientWidth, 0);
    const looping = Boolean(rail.closest('.keep-browsing--hero'));
    const atStart = !looping && rail.scrollLeft <= 4;
    const atEnd = !looping && rail.scrollLeft >= maxScroll - 4;

    if (prev) {
      prev.disabled = maxScroll <= 0 || atStart;
      prev.setAttribute('aria-disabled', prev.disabled ? 'true' : 'false');
    }

    if (next) {
      next.disabled = maxScroll <= 0 || atEnd;
      next.setAttribute('aria-disabled', next.disabled ? 'true' : 'false');
    }
  };

  const rails = Array.from(document.querySelectorAll('[data-product-rail]'));
  const refreshRailControls = () => {
    rails.forEach(updateRailControls);
  };

  const initRailScrubber = (rail) => {
    const section = rail.closest('.product-rail');
    if (!section) return;

    let scrubber = section.querySelector('[data-product-rail-scrubber], [data-employee-rail-slider]');
    let input = section.querySelector('[data-rail-scrubber-input], [data-employee-rail-range]');
    if (!scrubber || !input) return;

    if (input.matches('[data-employee-rail-range]')) {
      const replacement = input.cloneNode(true);
      replacement.removeAttribute('data-employee-rail-range');
      replacement.setAttribute('data-rail-scrubber-input', '');
      input.replaceWith(replacement);
      input = replacement;
      scrubber.removeAttribute('data-employee-rail-slider');
      scrubber.setAttribute('data-product-rail-scrubber', '');
      scrubber.classList.add('product-rail__scrubber', 'product-rail__scrubber--employee');
    }

    const scrubberMax = 1000;
    let scrubbing = false;
    let ticking = false;
    let scrubberPointerId = null;
    let scrubberStartX = 0;
    let scrubberStartScrollLeft = 0;

    const maxScroll = () => Math.max(rail.scrollWidth - rail.clientWidth, 0);
    const valueFromScroll = () => {
      const max = maxScroll();
      if (max <= 0) return 0;
      return Math.round((rail.scrollLeft / max) * scrubberMax);
    };
    const scrollFromValue = () => {
      const max = maxScroll();
      const value = Math.min(Math.max(Number(input.value || 0), 0), scrubberMax);
      return (value / scrubberMax) * max;
    };

    const setProgress = (forceInputValue = false) => {
      const max = maxScroll();
      const value = max > 0 ? valueFromScroll() : 0;
      const progress = max > 0 ? value / scrubberMax : 0;
      input.max = String(scrubberMax);
      input.disabled = max <= 4;
      scrubber.hidden = max <= 4;
      if (!scrubbing || forceInputValue === true) input.value = String(value);
      scrubber.style.setProperty('--rail-progress', `${Math.round(progress * 100)}%`);
    };

    const setScrubbing = (active) => {
      scrubbing = active;
      section.classList.toggle('is-scrubbing-rail', active);
    };

    const syncFromInput = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        rail.scrollLeft = scrollFromValue();
        ticking = false;
        setProgress();
        updateRailControls(rail);
      });
    };

    const finishScrub = () => {
      if (!scrubbing) return;
      syncFromInput();
      window.requestAnimationFrame(() => {
        setScrubbing(false);
        setProgress();
      });
    };

    const beginScrubberDrag = (event) => {
      if (event.button !== 0 || scrubberPointerId !== null) return;
      scrubberPointerId = event.pointerId;
      scrubberStartX = event.clientX;
      scrubberStartScrollLeft = rail.scrollLeft;
      setScrubbing(true);
      scrubber.setPointerCapture?.(event.pointerId);
      if (event.cancelable) event.preventDefault();
    };

    const moveScrubberDrag = (event) => {
      if (event.pointerId !== scrubberPointerId) return;
      const max = maxScroll();
      if (max <= 4) return;
      const width = Math.max(input.getBoundingClientRect().width, 1);
      const delta = ((event.clientX - scrubberStartX) / width) * max;
      rail.scrollLeft = Math.min(Math.max(scrubberStartScrollLeft + delta, 0), max);
      setProgress(true);
      updateRailControls(rail);
      if (event.cancelable) event.preventDefault();
    };

    const endScrubberDrag = (event) => {
      if (event.pointerId !== scrubberPointerId) return;
      if (scrubber.hasPointerCapture?.(scrubberPointerId)) scrubber.releasePointerCapture(scrubberPointerId);
      scrubberPointerId = null;
      setScrubbing(false);
      setProgress(true);
      updateRailControls(rail);
      if (event.cancelable) event.preventDefault();
    };

    scrubber.addEventListener('pointerdown', beginScrubberDrag);
    scrubber.addEventListener('pointermove', moveScrubberDrag);
    scrubber.addEventListener('pointerup', endScrubberDrag);
    scrubber.addEventListener('pointercancel', endScrubberDrag);

    input.addEventListener('pointerdown', (event) => {
      setScrubbing(true);
      if (event.cancelable) event.preventDefault();
    });
    input.addEventListener('input', () => {
      setScrubbing(true);
      syncFromInput();
    });
    input.addEventListener('change', finishScrub);
    input.addEventListener('blur', finishScrub);
    input.addEventListener('pointercancel', finishScrub);
    window.addEventListener('pointerup', finishScrub, { passive: true });

    rail.addEventListener('scroll', () => {
      if (scrubbing) return;
      window.requestAnimationFrame(setProgress);
    }, { passive: true });

    setProgress();
    window.addEventListener('load', setProgress, { once: true });
    window.addEventListener('resize', setProgress, { passive: true });
    [120, 420, 1000, 1800].forEach((delay) => window.setTimeout(setProgress, delay));
  };

  const enableProductRailDrag = (rail) => {
    if (rail.dataset.dragScrollReady === 'true') return;
    const canUseMouseDrag = typeof window.matchMedia !== 'function' || window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const isFooterCategoryRail = Boolean(rail.closest('.keep-browsing--footer'));
    if (!canUseMouseDrag || rail.classList.contains('keep-browsing__viewport--marquee') || isFooterCategoryRail) return;

    rail.dataset.dragScrollReady = 'true';
    let pointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let didDrag = false;
    let suppressClick = false;
    const isInteractiveRailTarget = (target) => target.closest(
      '[data-inert-link], [data-product-rail-scrubber], .product-rail__scrubber, [data-rail-scrubber-input], .product-card, .browse-category-card[href], .product-rail__track, .keep-browsing__center-handle, .rail-controls button, .rail-controls a, [data-rail-prev], [data-rail-next], a, button'
    );

    rail.addEventListener('pointerdown', (event) => {
      if (event.button !== 0 || pointerId !== null) return;
      if (event.target !== rail) return;
      if (event.target instanceof Element && isInteractiveRailTarget(event.target)) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = rail.scrollLeft;
      didDrag = false;
      rail.setPointerCapture?.(event.pointerId);
    });

    rail.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      const deltaX = event.clientX - startX;
      if (Math.abs(deltaX) <= 8) return;
      didDrag = true;
      rail.classList.add('is-dragging');
      rail.scrollLeft = startScrollLeft - deltaX;
      updateRailControls(rail);
      if (event.cancelable) event.preventDefault();
    });

    const endDrag = (event) => {
      if (event.pointerId !== pointerId) return;
      if (rail.hasPointerCapture?.(pointerId)) rail.releasePointerCapture(pointerId);
      if (didDrag) {
        suppressClick = true;
        window.setTimeout(() => {
          suppressClick = false;
        }, 260);
      }
      pointerId = null;
      didDrag = false;
      rail.classList.remove('is-dragging');
      updateRailControls(rail);
    };

    rail.addEventListener('pointerup', endDrag);
    rail.addEventListener('pointercancel', endDrag);
    rail.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);
    rail.addEventListener('dragstart', (event) => {
      event.preventDefault();
    });
  };

  rails.forEach((rail) => {
    initRailScrubber(rail);
    enableProductRailDrag(rail);
    updateRailControls(rail);
    rail.addEventListener('scroll', () => {
      if (rail.dataset.scrollTicking === 'true') return;
      rail.dataset.scrollTicking = 'true';
      window.requestAnimationFrame(() => {
        updateRailControls(rail);
        rail.dataset.scrollTicking = 'false';
      });
    }, { passive: true });
  });

  document.querySelectorAll('.keep-browsing--footer .browse-category-card[href]').forEach((card) => {
    card.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      window.location.assign(card.href);
    });
  });

  document.addEventListener('gearonimo:rail:update', (event) => {
    const rail = event.detail?.rail;
    if (rail instanceof HTMLElement && rail.matches('[data-product-rail]')) {
      updateRailControls(rail);
      return;
    }
    refreshRailControls();
  });

  window.addEventListener('load', refreshRailControls, { once: true });
  [120, 420, 1000, 1800].forEach((delay) => {
    window.setTimeout(refreshRailControls, delay);
  });

  if ('ResizeObserver' in window) {
    const railObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => updateRailControls(entry.target));
    });
    rails.forEach((rail) => railObserver.observe(rail));
  } else {
    window.addEventListener('resize', () => rails.forEach(updateRailControls), { passive: true });
  }
})();

// Header category links cache refresh 20260813.
